/**
 * Nederlands naar Engels voor de schermen buiten het menu (NL/EN-batch A2).
 * De sleutel is de Nederlandse tekst zoals hij in de bron staat, letterlijk.
 */
export const EN_VAN_NL = {
  "Via P2P gerouteerd ({n} deelnemers)": "Routed via P2P ({n} peers)",
  "{a} van {b} modellen eens": "{a} of {b} models agree",
  "Geen antwoord: {fout}": "No answer: {fout}",
  "Wijkt af: {reden}": "Dissents: {reden}",
  "Lokaal: {model}": "Local: {model}",
  "Verstuurd naar {aan}": "Sent to {aan}",
  "Aan {aan} - {onderwerp}": "To {aan} - {onderwerp}",
  "Precies deze tekst versturen": "Send this exact text",
  "Antwoord aan {afzender} - {onderwerp}": "Reply to {afzender} - {onderwerp}",
  "Teruglezen": "Read it back",
  "Nu: {aanbieder} / {model}": "Now: {aanbieder} / {model}",
  "Zou worden: {aanbieder} / {model}": "Would become: {aanbieder} / {model}",
  "onbekend": "unknown",
  "Versturen naar {aanbieder}": "Send to {aanbieder}",
  "aanbieder": "provider",
  "Gewijzigd in TASQ, werkruimte {naam}.": "Changed in TASQ, workspace {naam}.",
  "Status: {waarde}": "Status: {waarde}",
  "Deadline: {waarde}": "Deadline: {waarde}",
  "Bevestig": "Confirm",
  "Aangemaakt in {naam}": "Created in {naam}",
  "\"{tekst}\" kon ik niet als datum lezen, dus deze taak heeft geen deadline.": "I could not read \"{tekst}\" as a date, so this task has no deadline.",
  "Tijdmachine": "Time machine",
  "Ga": "Go",
  "{berichten} over {dagen}": "{berichten} over {dagen}",
  "1 bericht": "1 message",
  "{n} berichten": "{n} messages",
  "1 dag": "1 day",
  "{n} dagen": "{n} days",
  "Raad in zitting, 1 lid heeft geantwoord": "Council in session, 1 member has answered",
  "Raad in zitting, {n} leden hebben geantwoord": "Council in session, {n} members have answered",
  "ongewijzigd overgenomen, van de laatste {n}.": "taken over unchanged, out of the last {n}.",
  "herschreven voor het aannemen": "rewritten before accepting",
  "{wat} bevestigen": "Confirm {wat}",
  "Plugins": "Plugins",
  "{naam} openen": "Open {naam}",
  "Uitvoer": "Output",
  "Maak skill": "Create skill",
  "Geen resultaten voor \"{vraag}\"": "No results found for \"{vraag}\"",
  "Prompt": "Prompt",
  "Sleutel ophalen bij": "Get key from",
  "{n} sleutel(s)": "{n} key(s)",
  "Nieuwe sleutel voor {naam}": "New key for {naam}",
  "Systeemprompt": "System prompt",
  "Logo": "Logo",
  "Merklogo": "Brand logo",
  "Hoe vrij het model zijn woorden kiest. Laat leeg voor de standaard van {n}, die antwoorden stabiel genoeg houdt om te vergelijken. Zet hem hoger voor schrijfwerk.": "How freely the model picks its words. Leave empty for the default of {n}, which keeps answers steady enough to compare. Raise it for writing work.",
  "standaard ({n})": "default ({n})",
  "Skills": "Skills",
  "Kennis": "Knowledge",
  // GL214-2: een gesprek uit Fathom in het bronnenblok.
  "Terugkijken in Fathom": "Watch in Fathom",
  // GL214-5
  "De worker is aangemaakt en staat bij Agenten.": "The worker has been created and is in Agents.",
  "Aanwezig": "Attendees",
  // Blok 3: het voorstel van de agent in het scherm Code.
  "Voorstel van de agent": "The agent's proposal",
  "Er staat niets meer open in het voorstel.": "Nothing is left open in the proposal.",
  "De werkruimte verandert pas als je een bestand toepast.": "The workspace only changes when you apply a file.",
  "gewijzigd": "changed",
  "Weigeren": "Reject",
  "Toepassen": "Apply",
  "Toegepast: {pad}": "Applied: {pad}",
  "Geweigerd: {pad}": "Rejected: {pad}",
  "Dat lukte niet.": "That did not work.",
  "De werkruimte staat weer zoals voor de agentrit.": "The workspace is back as it was before the agent run.",
  "Terugdraaien lukte niet.": "Undoing did not work.",
  "De diff is ingekort; toepassen neemt het hele bestand over.": "The diff is shortened; applying takes the whole file.",
  "Terugdraaien naar voor de agentrit": "Undo to before the agent run",
  "Start": "Start",
  "Model": "Model",
  "Model voor code": "Model for code",
  "Denkniveau": "Thinking level",
  "Laag": "Low",
  "Gemiddeld": "Medium",
  "Hoog": "High",
  "Het denkniveau kon niet worden gekozen.": "The thinking level could not be chosen.",
  "denken: {niveau}": "thinking: {niveau}",
  "laag": "low",
  "gemiddeld": "medium",
  "hoog": "high",
  "gekozen voor dit gesprek": "chosen for this conversation",
  "Model voor dit gesprek": "Model for this conversation",
  "Zoek een model": "Search a model",
  "Favorieten": "Favourites",
  "Uit favorieten": "Remove from favourites",
  "Naar favorieten": "Add to favourites",
  "Geen model gevonden": "No model found",
  "Standaard uit Instellingen": "Default from Settings",
  "Modellen verversen": "Refresh models",
  "Eigen model toevoegen": "Add your own model",
  "Het model kon niet worden gekozen.": "The model could not be chosen.",
  "Deze Mac: {chip}, {gb} GB": "This Mac: {chip}, {gb} GB",
  "Een model past als het hooguit {procent} procent van het geheugen gebruikt; de rest is voor de context en de app.": "A model fits if it uses at most {procent} percent of the memory; the rest is for the context and the app.",
  "past": "fits",
  "past niet": "does not fit",
  "Advies voor deze Mac: {model}": "Advice for this Mac: {model}",
  "niet geinstalleerd": "not installed",
  "grootte uit een externe bron, niet officieel bevestigd": "size from an external source, not officially confirmed",
  "Ollama gaf geen lijst; de machine en het advies blijven zichtbaar.": "Ollama gave no list; the machine and the advice stay visible.",
  // LC2: de meetset voor code.
  "Meetset voor code": "Test set for code",
  "Per model: hoeveel van de {n} codeopdrachten echt lukken. Een opdracht lukt alleen als de code de toets in de sandbox doorstaat.": "Per model: how many of the {n} coding tasks really succeed. A task only succeeds when the code passes the test in the sandbox.",
  "Nog niet gemeten.": "Not measured yet.",
  "{a} van {b} lukken": "{a} of {b} succeed",
  "Bezig met meten...": "Measuring...",
  "Meet nu": "Measure now",
  "Verberg de opdrachten": "Hide the tasks",
  "Toon de opdrachten": "Show the tasks",
  "Herkomst: {bron}": "Source: {bron}",
  "De meting is niet gestart.": "The measurement did not start.",
  "Er staat op deze Mac geen model dat code kan.": "There is no model on this Mac that can write code.",
  "De meetset voor code staat uit (besluit Frank, 1 november 2026).": "The code measurement set is switched off (Frank's decision, 1 November 2026).",
  "Zelfde als de chat": "Same as the chat",
  // WB3 (4 nov 2026): het model voor code als de lijst niet laadt.
  "Niet geladen": "Not loaded",
  "De lijst met modellen kon niet laden. De bewaarde keuze staat hierboven.":
    "The list of models could not load. The saved choice is shown above.",
  "Het model voor code kon niet laden. Open Instellingen opnieuw om het nog eens te proberen.":
    "The model for code could not load. Open Settings again to try once more.",
  "Het model voor code is niet opgeslagen": "The model for code was not saved",
  "Geen lokaal model dat tekst en gereedschap kan. Code gebruikt het model van de chat.": "No local model that can do text and tools. Code uses the chat model.",
  "Alleen modellen die tekst en gereedschap kunnen staan in de lijst. Geldt als de chat lokaal draait.": "Only models that can do text and tools are listed. Applies when the chat runs locally.",
  "Verlaat de machine: deze run gaat naar {waar}.": "Leaves the machine: this run goes to {waar}.",
  "Antwoord sturen": "Send answer",
  "Deze agent verlaat de machine. Elke run gaat naar {waar}, niet naar het model op dit apparaat, en het spoor zegt dat.": "This agent leaves the machine. Every run of it goes to {waar}, not to the model on this device, and the trail will say so.",
  "Wat deze gereedschappen lezen gaat met de vraag naar {waar}. Daar horen ook de bestandsnamen bij in de kennisbanken op deze kaart.": "What these tools read goes to {waar} with the question. That includes the file names in the knowledge bases on this card.",
  "Nog geen kennisbanken.": "No knowledge bases yet.",
  "{n} deelnemers online": "{n} peers online",
  "{n} kernen": "{n} cores",
  "Geen": "None",
  "Deelnemers": "Peers",
  "{n} online": "{n} online",
  "{n} deelnemers": "{n} peers",
  "door {wie}": "by {wie}",
  "Verbonden nodes ({n})": "Connected nodes ({n})",
  "Node-ID": "Node ID",
  "Score": "Score",
  "Mag op het web": "May use the web",
  "Deze agent mag dan webpagina's lezen. Hij klikt niets aan en vult niets in, en elke pagina die hij leest staat in zijn spoor.": "This agent may then read web pages. It clicks nothing and fills in nothing, and every page it reads is in its trail.",
  "Webpagina gelezen: {url} ({uitkomst})": "Web page read: {url} ({uitkomst})",
  "1 document": "1 document",
  "{n} documenten": "{n} documents",
  "{n} onleesbaar": "{n} unreadable",
  "Project": "Project",
  "Algemeen (alle gesprekken)": "General (all conversations)",
  "Feiten (doorzocht in elk gesprek)": "Facts (searched in every conversation)",
  "Naslag (vormen en uitgewerkte voorbeelden)": "Reference (formats and worked examples)",
  "Opnieuw indexeren": "Reindex",
  "Map importeren": "Import folder",
  "{gevonden} bestand(en) gelezen: {toegevoegd} nieuw, {bijgewerkt} bijgewerkt, {overgeslagen} ongewijzigd": "{gevonden} file(s) read: {toegevoegd} new, {bijgewerkt} updated, {overgeslagen} unchanged",
  "Zoeken": "Search",
  "Zoekresultaten ({n} stukken)": "Search results ({n} chunks)",
  "[{f}] afstand: {d}": "[{f}] distance: {d}",
  "Status": "Status",
  "uit {p} gehaald": "taken out of {p}",
  "zijn project": "its project",
  "zojuist": "just now",
  "{n} min geleden": "{n} min ago",
  "{n} uur geleden": "{n} hours ago",
  "(laatst gekeken: {w}), en niet door de map. Er is niets half blijven staan; deze ronde is teruggedraaid.": "(last checked: {w}), and not because of the folder. Nothing was left half done; this round was rolled back.",
  "Bijgewerkt {w}, er was niets veranderd.": "Updated {w}, nothing had changed.",
  "Bijgewerkt {w}: {nieuw} nieuw, {gewijzigd} bijgewerkt, {weg} verwijderd.": "Updated {w}: {nieuw} new, {gewijzigd} updated, {weg} removed.",
  "{n} bestand(en) konden niet worden gelezen.": "{n} file(s) could not be read.",
  "Het logo moet kleiner zijn dan 350 KB": "The logo must be smaller than 350 KB",
  "Kon geen verbinding maken met Ollama": "Could not connect to Ollama",
  "API-sleutel opgeslagen": "API key saved",
  "API-sleutel opslaan is mislukt": "Saving the API key failed",
  "API-sleutel verwijderd": "API key deleted",
  "API-sleutel verwijderen is mislukt": "Deleting the API key failed",
  "Model downloaden is mislukt": "Downloading the model failed",
  "Instellingen opslaan is mislukt": "Saving the settings failed",
  "Instellingen": "Settings",
  "Stel je AI-aanbieder en voorkeuren in.": "Set your AI provider and preferences.",
  "Laden...": "Loading...",
  "Nog geen opdracht": "No brief yet",
  "(niet geïnstalleerd)": "(not installed)",
  "1 skill": "1 skill",
  "{n} skills": "{n} skills",
  "1 kennisbank": "1 knowledge base",
  "{n} kennisbanken": "{n} knowledge bases",
  "hooguit {n} rondes": "up to {n} rounds",
  "{n} gereedschappen": "{n} tools",
  "overal": "everywhere",
  "voor de hele organisatie": "for the whole organisation",
  "een project dat niet meer bestaat": "a project that no longer exists",
  "een werkruimte die niet meer bestaat": "a workspace that no longer exists",
  "project {naam}": "project {naam}",
  "werkruimte {naam}": "workspace {naam}",
  "van {bron}": "from {bron}",
  "vandaag om {tijd}": "today at {tijd}",
  "gisteren om {tijd}": "yesterday at {tijd}",
  "afgelopen {dag} om {tijd}": "last {dag} at {tijd}",
  "een week geleden": "a week ago",
  "Bezig. Hooguit 1 ronde, een aanroep van het model. Elke ronde verschijnt onder Laat je werk zien zodra hij klaar is.": "Running. Up to 1 round, one model call. Every round appears in Show your work when it finishes.",
  "Bezig. Hooguit {n} rondes, elk een aanroep van het model. Elke ronde verschijnt onder Laat je werk zien zodra hij klaar is.": "Running. Up to {n} rounds, one model call each. Every round appears in Show your work when it finishes.",
  "Hooguit {n} rondes. Elke ronde is een aanroep van het model, en of hij zegt klaar te zijn wordt nagekeken voordat de rit stopt.": "Up to {n} rounds. Each round is one call to the model, and saying it is finished is checked before the run stops.",
  "Geen skills geïnstalleerd.": "No skills installed.",
  "Chatten": "Chat",
  "Chatten over code": "Chat about code",
  "Chatten en analyseren": "Chat and analyse",
  "Lokale opslag": "Local storage",
  "Eigen huisstijl": "Custom branding",
  "Zoeken op internet": "Web search",
  "Webpagina's openen": "Open web pages",
  "Schermafbeelding van een webpagina": "Screenshot of a web page",
  "Basisskills": "Basic skills",
  "Synchronisatie via het lokale netwerk": "LAN P2P sync",
  "Code uitvoeren": "Code execution",
  "Persoonlijke kennisbank (RAG)": "Personal knowledge base (RAG)",
  "Teamkennisbank": "Team knowledge base",
  "Rekenkracht delen": "Compute-sharing pool",
  "Centrale facturering voor alle plaatsen": "Central billing across seats",
  "Volledige Galaxy-marktplaats": "Full Galaxy marketplace",
  "Skills publiceren in Galaxy": "Publish skills to Galaxy",
  "Klikken en werken op pagina's": "Click & interact with pages",
  "Typen in formulieren": "Type into forms",
  "Formulieren met meerdere velden invullen": "Fill multi-field forms",
  "Raad (overeenstemming tussen modellen)": "Council (multi-model consensus)",
  "Teamwerkruimtes": "Team workspaces",
  "Ondersteuning met voorrang": "Priority support",
  "1 taalmodel naar keuze": "1 LLM of your choice",
  "Onbeperkte lokale gespreksgeschiedenis": "Unlimited local conversation history",
  "CLAW-Runtime (alleen lezen: zoeken, bladeren, schermafbeelding)": "CLAW-Runtime (read-only: search, browse, screenshot)",
  "Basisskills uit Galaxy": "Basic Galaxy skills",
  "Synchronisatie via het lokale netwerk (je eigen apparaten)": "LAN P2P sync (your own devices)",
  "Lokale gegevensopslag": "Local data storage",
  "Eigen huisstijl (logo en kleuren)": "Custom branding (logo & colors)",
  "Afrekenen mislukt": "Checkout failed",
  "Licentie geactiveerd: {niveau}": "License activated: {niveau}",
  "Ongeldige licentie": "Invalid license",
  "Licentie op naam van {wie}": "Licensed to {wie}",
  "Licentie op jouw naam": "Licensed to you",
  "· verloopt op {datum}": "· expires {datum}",
  "POPULAIR": "POPULAR",
  "Klantportaal openen is mislukt": "Failed to open the billing portal",
  "Desktopmodus: de licentie wordt op dit apparaat gecontroleerd en er gaat niets naar een server. Stripe regelt alleen de betaling; opwaarderen zet de functies van het abonnement aan op dit apparaat.": "Desktop mode: the license is checked on this device and nothing is sent to a server. Stripe only handles payment; upgrading unlocks the plan's features on this device.",
  "{naam}-abonnement": "{naam} plan",
  "€{prijs} per maand": "€{prijs}/month",
  "verlengt op {datum}": "renews {datum}",
  "Wat er bij {naam} hoort": "What's included in {naam}",
  "Aanbieder": "Provider",
  "Sleutels": "Keys",
  "Routering": "Routing",
  "Merk": "Brand",
  "Telefoons": "Phones",
  "Identiteit": "Identity",
  "Verbindingen": "Connections",
  "Grenzen": "Limits",
  "Meer": "More",
  "Meer, tijdelijk": "More, temporary",
  "De oudere weg naar binnen, alleen bewaard zolang de directe verbinding zich bewijst. Hij heeft Tailscale nodig of een ander adres dat deze machine al bereikt, dus geef hem aan niemand anders. Hij verdwijnt zodra de directe verbinding haar plek heeft verdiend.": "The older way in, kept only while the direct connection proves itself. It needs Tailscale or another address this machine already reaches, so give it to nobody else. It disappears once the direct connection has earned its place.",
  "AI-aanbieder": "AI provider",
  "API-sleutel": "API key",
  "Geen sleutel ingesteld. Voeg er een toe onder Sleutels.": "No key set. Add one under Keys.",
  "Ollama-adres": "Ollama address",
  "Geen modellen gevonden. Download er hieronder een, of draai:": "No models found. Download one below, or run:",
  "Nieuw model downloaden": "Download a new model",
  "Downloaden": "Download",
  "bijv. llama3.2, mistral, codellama": "e.g. llama3.2, mistral, codellama",
  "Bewaar API-sleutels per aanbieder. Ze worden versleuteld opgeslagen.": "Store API keys per provider. They are stored encrypted.",
  "Sleutel toevoegen": "Add key",
  "Annuleren": "Cancel",
  "Typ de systeemprompt...": "Type the system prompt...",
  "Deze prompt bepaalt de persoonlijkheid en het gedrag van de AI.": "This prompt sets the personality and behaviour of the AI.",
  "Terug naar standaard": "Back to default",
  "Jouw merk, jouw wereld. Deze instellingen geven de app jouw stijl en sturen hoe de AI schrijft.": "Your brand, your world. These settings give the app your style and steer how the AI writes.",
  "Naam van de werkruimte": "Workspace name",
  "bijv. Plexaris": "e.g. Plexaris",
  "Accentkleur": "Accent colour",
  "Kies een accentkleur": "Choose an accent colour",
  "#FF6B35 (leeg = standaard)": "#FF6B35 (empty = default)",
  "geen": "none",
  "Uploaden": "Upload",
  "Verwijderen": "Delete",
  "Blijft op je machine, lokaal bewaard bij je werkruimte.": "Stays on your machine, stored locally with your workspace.",
  "Toon": "Tone",
  "bijv. Warm, direct, geen kantoorjargon. Korte zinnen.": "e.g. Warm, direct, no office jargon. Short sentences.",
  "Woordkeus": "Word choice",
  "Takken": "Branches",
  "De opmerking kon niet worden geplaatst.": "The comment could not be posted.",
  "De beoordeling kon niet worden opgeslagen.": "The review could not be saved.",
  "De kaart Samenvoegen kon niet worden getoond.": "The merge card could not be shown.",
  "Samengevoegd met een merge commit.": "Merged with a merge commit.",
  "Samenvoegen lukte niet.": "Merging did not work.",
  "Wijzigingen gevraagd": "Changes requested",
  "Samengevoegd met merge commit {sha}.": "Merged with merge commit {sha}.",
  "Bij welk bestand": "Which file",
  "Bij de hele pull request": "On the whole pull request",
  "regel": "line",
  "Regelnummer": "Line number",
  "Schrijf een opmerking": "Write a comment",
  "Opmerking plaatsen": "Post comment",
  "Goedkeuren": "Approve",
  "Wijzigingen vragen": "Request changes",
  "Samenvoegen": "Merge",
  "Voeg {van} samen in {naar} met een merge commit.": "Merge {van} into {naar} with a merge commit.",
  "{naar} is beschermd: dit is de enige weg waarlangs hij verandert.": "{naar} is protected: this is the only way it changes.",
  "Er is een conflict in {bestanden}. Los het op in de tak en probeer opnieuw.": "There is a conflict in {bestanden}. Resolve it in the branch and try again.",
  "Annuleer": "Cancel",
  "Pull requests": "Pull requests",
  "Laat de agent dit oplossen": "Let the agent solve this",
  "Pull request #{n} geopend: {titel}. Samenvoegen doe jij, in Repo's.": "Pull request #{n} opened: {titel}. You do the merge, in Repos.",
  "De toetsen waren niet groen na de laatste wijziging; er is geen pull request geopend.": "The tests were not green after the last change; no pull request was opened.",
  "Het werk staat in de open pull request #{n}: {titel}. Samenvoegen doe jij, in Repo's.": "The work is in the open pull request #{n}: {titel}. You do the merge, in Repos.",
  // EG9: importeren en spiegelen met GitHub.
  "Repo {naam} geïmporteerd.": "Repo {naam} imported.",
  "{n} bestanden in de map waren nog niet vastgelegd en gingen niet mee.": "{n} files in the folder were not committed yet and were left out.",
  "Importeren lukte niet.": "Importing failed.",
  "Waar komt de repo vandaan": "Where does the repo come from",
  "Van GitHub": "From GitHub",
  "Uit een map op deze Mac": "From a folder on this Mac",
  "Adres op GitHub": "Address on GitHub",
  "Wie is de bron?": "Which is the source?",
  "GitHub blijft de bron: NovaMund spiegelt hem en je leest hem hier, je werkt er niet in.": "GitHub stays the source: NovaMund mirrors it and you read it here, you do not work in it.",
  "Eenmalig importeren: daarna is NovaMund de bron.": "Import once: after that NovaMund is the source.",
  "NovaMund gebruikt geen inlog van GitHub. Een privé-repo vraagt een leestoken dat je zelf op GitHub maakt; het gaat alleen met deze import mee en wordt nergens bewaard.": "NovaMund uses no GitHub sign-in. A private repo needs a read token you create on GitHub yourself; it goes along with this import only and is stored nowhere.",
  "Leestoken van GitHub (alleen voor een privé-repo)": "GitHub read token (only for a private repo)",
  "Leestoken van GitHub": "GitHub read token",
  "Volledig pad van de git-map die overgaat": "Full path of the git folder that moves",
  "Je kiest zelf welke repo overgaat. De kaart leest de map zonder er iets te schrijven; pas na Bevestig gaat hij over. De map, zijn remote en GitHub blijven zoals ze zijn.": "You choose which repo moves. The card reads the folder without writing to it; it only moves after Confirm. The folder, its remote and GitHub stay as they are.",
  "{lokaal} lokale takken, {daar} alleen op GitHub, {apart} apart onder github/; samen {na} takken, {tags} tags, {n} vastleggingen.": "{lokaal} local branches, {daar} only on GitHub, {apart} separately under github/; together {na} branches, {tags} tags, {n} commits.",
  "Hoofdtak: {tak}. GitHub: {adres}, blijft staan.": "Main branch: {tak}. GitHub: {adres}, stays.",
  "Wat er gebeurt, stap voor stap:": "What happens, step by step:",
  "Bevestig: verhuis deze repo": "Confirm: move this repo",
  "Verhuisd. De map en zijn remote zijn ongewijzigd.": "Moved. The folder and its remote are unchanged.",
  "Verhuisd, maar de map veranderde tijdens het verhuizen; kijk de map na.": "Moved, but the folder changed during the move; check the folder.",
  "Verhuizen lukte niet.": "Moving did not work.",
  "Deze bevestiging is niet (meer) geldig. Er is niets verhuisd; open de kaart opnieuw.": "This confirmation is not (or no longer) valid. Nothing was moved; open the card again.",
  "De map is veranderd sinds de kaart werd getoond. Er is niets verhuisd; bekijk de kaart opnieuw.": "The folder changed since the card was shown. Nothing was moved; look at the card again.",
  "de map lezen, zonder er iets te schrijven": "read the folder, without writing to it",
  "de lokale takken en alle tags overnemen": "take over the local branches and all tags",
  "de takken die alleen op GitHub staan overnemen, en een uiteenlopende tak apart als github/<naam>": "take over the branches that are only on GitHub, and a diverging branch separately as github/<naam>",
  "controleren dat elke tak, tag en vastlegging gelijk is, zonder remote, en git fsck": "check that every branch, tag and commit is equal, without a remote, and git fsck",
  "de repo registreren met hoofdtak main en de bescherming daarop": "register the repo with main as the main branch and its protection",
  "Inklappen": "Collapse",
  "Uitklappen": "Expand",
  "Verhuizen uit een git-map, met alles": "Move from a git folder, with everything",
  "Verhuizen vraagt een git-map, met zijn geschiedenis. Er is niets verhuisd.": "Moving needs a git folder, with its history. Nothing was moved.",
  "De kaart kon niet worden getoond.": "The card could not be shown.",
  "Tak {naam} staat op GitHub.": "Branch {naam} is on GitHub.",
  "Duwen naar GitHub lukte niet.": "Pushing to GitHub did not work.",
  "Er is geen tak om naar GitHub te duwen: de hoofdtak gaat daar nooit heen.": "There is no branch to push to GitHub: the main branch never goes there.",
  "Een tak naar GitHub duwen": "Push a branch to GitHub",
  "Toon wat er gebeurt": "Show what happens",
  "Tak {tak} op vastlegging {sha} gaat naar {adres}. Niet geforceerd: staat daar iets wat hier niet is, dan weigert GitHub.": "Branch {tak} at commit {sha} goes to {adres}. Not forced: if something is there that is not here, GitHub refuses.",
  "Token van GitHub met schrijfrecht": "GitHub token with write access",
  "Deze bevestiging is niet (meer) geldig. Er is niets naar GitHub geduwd; open de kaart opnieuw.": "This confirmation is not (or no longer) valid. Nothing was pushed to GitHub; open the card again.",
  "De tak is veranderd sinds de kaart werd getoond. Er is niets naar GitHub geduwd; bekijk hem opnieuw.": "The branch changed since the card was shown. Nothing was pushed to GitHub; look at it again.",
  "Naar de hoofdtak op GitHub duwt NovaMund nooit (G6): die verandert alleen via een pull request op GitHub zelf. Kies een andere tak. Er is niets geduwd.": "NovaMund never pushes to the main branch on GitHub (G6): it only changes through a pull request on GitHub itself. Choose another branch. Nothing was pushed.",
  "Deze repo kwam niet van GitHub, dus er is geen adres om naar te duwen. Er is niets geduwd.": "This repo did not come from GitHub, so there is no address to push to. Nothing was pushed.",
  "GitHub weigerde het duwen: op die tak staat daar iets wat hier niet is. NovaMund forceert nooit; er is niets overschreven.": "GitHub refused the push: that branch has something there that is not here. NovaMund never forces; nothing was overwritten.",
  "GitHub weigerde dit token voor schrijven naar deze repo: het is verlopen of mist schrijfrecht op de inhoud. Het token is niet bewaard. Er is niets geduwd.": "GitHub refused this token for writing to this repo: it has expired or lacks write access to the contents. The token was not stored. Nothing was pushed.",
  "Vul een token van GitHub met schrijfrecht in; het wordt alleen voor deze keer gebruikt. Er is niets geduwd.": "Fill in a GitHub token with write access; it is used this once only. Nothing was pushed.",
  "Geen geldige vastlegging. Er is niets geduwd.": "Not a valid commit. Nothing was pushed.",
  "Volledig pad van de map": "Full path of the folder",
  "Een git-map komt mee met al zijn takken en geschiedenis; anders worden de bestanden de eerste vastlegging op main. De map zelf wordt alleen gelezen.": "A git folder comes along with all its branches and history; otherwise the files become the first commit on main. The folder itself is only read.",
  "Naam van de repo (mag leeg)": "Name of the repo (may be empty)",
  "Ververst: {b} bijgewerkt, {n} nieuw, {w} weg.": "Refreshed: {b} updated, {n} new, {w} removed.",
  "Ververst: alles was al gelijk aan GitHub.": "Refreshed: everything already matched GitHub.",
  "Losgemaakt van GitHub: NovaMund is nu de bron.": "Detached from GitHub: NovaMund is now the source.",
  "Spiegel van {adres}: GitHub is de bron, hier alleen te lezen.": "Mirror of {adres}: GitHub is the source, read-only here.",
  "Laatst ververst {wanneer}.": "Last refreshed {wanneer}.",
  "Ververs vanaf GitHub": "Refresh from GitHub",
  "Zeker weten? Terug naar spiegelen kan niet.": "Are you sure? Going back to mirroring is not possible.",
  "Maak los van GitHub": "Detach from GitHub",
  "spiegel van GitHub": "mirror of GitHub",
  "GitHub gaf deze repo niet zonder inloggen: hij is privé of bestaat niet. Vul voor een privé-repo een leestoken van GitHub in; het wordt alleen voor deze keer gebruikt en nergens bewaard. Er is niets geïmporteerd.": "GitHub would not give this repo without signing in: it is private or does not exist. For a private repo, fill in a GitHub read token; it is used this once only and stored nowhere. Nothing was imported.",
  "GitHub weigerde dit leestoken voor deze repo: het is verlopen, mist leesrecht op de inhoud, of de repo bestaat niet. Het token is niet bewaard. Er is niets veranderd.": "GitHub refused this read token for this repo: it has expired, lacks read access to the contents, or the repo does not exist. The token was not stored. Nothing changed.",
  "Dit lijkt geen leestoken van GitHub (alleen letters, cijfers en _). Er is niets gedaan.": "This does not look like a GitHub read token (letters, digits and _ only). Nothing was done.",
  "Een leestoken gaat alleen mee naar GitHub over https. Er is niets gedaan.": "A read token only goes to GitHub over https. Nothing was done.",
  "Deze spiegel is privé op GitHub: vul het leestoken in om te verversen. Het wordt alleen voor deze keer gebruikt en nergens bewaard. Er is niets veranderd.": "This mirror is private on GitHub: fill in the read token to refresh. It is used this once only and stored nowhere. Nothing changed.",
  "Geef het adres van een repo op GitHub, zoals https://github.com/eigenaar/naam.": "Give the address of a repo on GitHub, like https://github.com/owner/name.",
  "Geef het volledige pad van een map op deze Mac, zoals /Users/naam/project.": "Give the full path of a folder on this Mac, like /Users/name/project.",
  "Deze map hoort bij NovaMund zelf en kan niet worden geïmporteerd.": "This folder belongs to NovaMund itself and cannot be imported.",
  "De map is leeg; er is niets geïmporteerd.": "The folder is empty; nothing was imported.",
  "Kies importeren uit een map of van GitHub.": "Choose importing from a folder or from GitHub.",
  "Deze repo is geen spiegel van GitHub; er valt niets te verversen.": "This repo is not a mirror of GitHub; there is nothing to refresh.",
  "Deze repo is geen spiegel van GitHub; NovaMund is al de bron.": "This repo is not a mirror of GitHub; NovaMund is already the source.",
  // CA3: een app draaien en bekijken.
  "De pagina kwam niet; kijk in de log of de server luistert.": "The page did not come; check the log to see whether the server is listening.",
  "Open eerst het bestand dat de server is.": "First open the file that is the server.",
  "De server kon niet starten.": "The server could not start.",
  "Of draai het open bestand als server en bekijk de app": "Or run the open file as a server and view the app",
  "Stop de server": "Stop the server",
  "Start als server": "Start as server",
  "Luistert op poort {poort}": "Listening on port {poort}",
  "Start op poort {poort}…": "Starting on port {poort}…",
  "Voorbeeld": "Preview",
  "De server stopte met code {code}.": "The server stopped with code {code}.",
  "Op de telefoon toont het voorbeeld de pagina zelf; plaatjes, stijlen en scripts die de pagina los ophaalt, komen niet door de verbinding.": "On the phone the preview shows the page itself; images, styles and scripts the page fetches separately do not come through the connection.",
  "Ververs het voorbeeld": "Refresh the preview",
  "Voorbeeld van de app": "Preview of the app",
  "In deze werkruimte draait geen server.": "No server is running in this workspace.",
  "Dit bestand staat niet in de werkruimte.": "This file is not in the workspace.",
  "Een server draaien vraagt de sandbox van macOS, en die ontbreekt hier. Er draait niets.": "Running a server needs the macOS sandbox, which is missing here. Nothing is running.",
  "Dit voorbeeld bestaat niet (meer); start de server opnieuw.": "This preview does not exist (any more); start the server again.",
  // CA5: een app starten vanuit de chat.
  "De repo {naam} en de werkruimte staan er; de agent begint in Code.": "The repo {naam} and the workspace are there; the agent starts in Code.",
  "Repo {naam}, met een werkruimte erop": "Repo {naam}, with a workspace on it",
  "Opdracht voor de agent: {opdracht}": "Task for the agent: {opdracht}",
  "De agent werkt op een novamund-tak en stelt elke wijziging voor; jij past per bestand toe. Naar main gaat alleen via een pull request na jouw klik.": "The agent works on a novamund branch and proposes every change; you apply file by file. Main only changes through a pull request after your click.",
  "Bevestig en maak de repo en de werkruimte": "Confirm and create the repo and the workspace",
  "Aangemaakt; de agent is in Code begonnen.": "Created; the agent has started in Code.",
  "Dit voorstel bestaat niet, of het is niet van jou.": "This proposal does not exist, or it is not yours.",
  "Deze bevestiging is niet (meer) geldig. Er is niets aangemaakt; open de kaart opnieuw.": "This confirmation is not valid (any more). Nothing was created; open the card again.",
  "Wat nu wordt aangeboden is niet wat op het scherm heeft gestaan. Er is niets aangemaakt.": "What is offered now is not what was on the screen. Nothing was created.",
  "Dit voorstel is al bevestigd; er is niets dubbel aangemaakt.": "This proposal has already been confirmed; nothing was created twice.",
  "Als kijker in deze organisatie kun je geen app laten bouwen.": "As a viewer in this organisation you cannot have an app built.",
  // CA6: opslaan en meenemen.
  "Vastlegboodschap bij Toepassen (mag leeg)": "Commit message on Apply (may be empty)",
  "{naam} staat in Downloads.": "{naam} is in Downloads.",
  "{naam} wordt gedownload.": "{naam} is being downloaded.",
  "Meenemen lukte niet.": "Taking it along failed.",
  "Download als bundel, met geschiedenis": "Download as a bundle, with history",
  "Download {tak} als zip": "Download {tak} as a zip",
  "Van een bundel maak je overal weer een repo met git clone <bestand>, of hier met Importeren. Hooguit 10 MB.": "From a bundle you make a repo again anywhere with git clone <file>, or here with Import. At most 10 MB.",
  "Klonen op deze Mac, buiten NovaMund, in Terminal:": "Clone on this Mac, outside NovaMund, in Terminal:",
  "Een kopie buiten deze Mac komt later, met je keuze bij EV2.": "A copy outside this Mac comes later, with your choice at EV2.",
  "Meenemen": "Take along",
  "Uit een bundel op deze Mac": "From a bundle on this Mac",
  "Volledig pad van de bundel": "Full path of the bundle",
  "Een bundel komt mee met al zijn takken en geschiedenis. Het bestand zelf wordt alleen gelezen.": "A bundle comes along with all its branches and history. The file itself is only read.",
  "Kies een bundel (met geschiedenis) of een zip (alleen de bestanden).": "Choose a bundle (with history) or a zip (only the files).",
  "Dit bestand is geen geldige bundel; er is niets geïmporteerd.": "This file is not a valid bundle; nothing was imported.",
  "Geef het volledige pad van een bundel op deze Mac, zoals /Users/naam/project.bundle.": "Give the full path of a bundle on this Mac, like /Users/name/project.bundle.",
  // CA7: een hele app in deelstappen.
  "Het plan kon niet worden gemaakt.": "The plan could not be made.",
  "De deelstap kon niet starten.": "The step could not start.",
  "Of laat de agent een hele app bouwen in deelstappen": "Or let the agent build a whole app in steps",
  "Wat moet de app doen?": "What should the app do?",
  "Bijvoorbeeld: een app die mijn uren per week telt, met toetsen": "For example: an app that counts my hours per week, with tests",
  "Maak het plan": "Make the plan",
  "{gebruikt} van {budget} minuten gebruikt": "{gebruikt} of {budget} minutes used",
  "Alle deelstappen zijn klaar.": "All steps are done.",
  "Pas na elke deelstap de bestanden toe of weiger ze; daarna start Bevestig de volgende.": "After each step, apply or reject the files; then Confirm starts the next one.",
  "Bevestig en hervat deelstap {nr}": "Confirm and resume step {nr}",
  "Bevestig en start deelstap {nr}": "Confirm and start step {nr}",
  "Gooi het plan weg": "Discard the plan",
  "klaar": "done",
  "gestopt": "stopped",
  "bezig": "running",
  "In deze werkruimte loopt al een app-opdracht in deelstappen; maak die af of gooi hem weg.": "An app task in steps is already running in this workspace; finish it or discard it.",
  "Het model gaf geen plan met genummerde deelstappen; er is niets begonnen. Probeer het opnieuw.": "The model gave no plan with numbered steps; nothing was started. Try again.",
  "In deze werkruimte is geen app-opdracht in deelstappen.": "There is no app task in steps in this workspace.",
  "Er loopt al een deelstap.": "A step is already running.",
  "Pas eerst elk bestand uit het voorstel toe, of weiger het; dan start de volgende deelstap.": "First apply or reject every file in the proposal; then the next step starts.",
  // Glasronde 0.9.231 punt 1.
  "Pas eerst elk bestand uit het voorstel toe, of weiger het; dan start de agent een nieuwe rit.": "First apply or reject every file in the proposal; then the agent starts a new run.",
  // Glasronde 0.9.231 punt 3.
  "Opnieuw gevraagd": "Asked again",
  "Het tijdsbudget van 60 minuten voor deze app-opdracht is op.": "The 60 minute time budget for this app task is used up.",
  "Er loopt nog een deelstap; stop die eerst.": "A step is still running; stop it first.",
  "Na samenvoegen sluit: {issues}.": "After merging, this closes: {issues}.",
  "De samengevoegde takken konden niet worden opgehaald.": "The merged branches could not be loaded.",
  "{n} takken opgeruimd.": "{n} branches cleaned up.",
  "Opruimen lukte niet.": "Cleaning up did not work.",
  "Samengevoegde takken opruimen": "Clean up merged branches",
  "Er zijn geen takken die al helemaal in {hoofd} zitten.": "There are no branches that are already fully in {hoofd}.",
  "blijft: de werkruimte {naam} werkt erop": "stays: the workspace {naam} works on it",
  "Verwijder {n} samengevoegde takken": "Delete {n} merged branches",
  "Issues": "Issues",
  "Terug naar de issues": "Back to the issues",
  "Het issue kon niet worden geopend.": "The issue could not be opened.",
  "Het issue kon niet worden gemaakt.": "The issue could not be created.",
  "De labels konden niet worden opgeslagen.": "The labels could not be saved.",
  "Labels, met komma's ertussen": "Labels, separated by commas",
  "Labels opslaan": "Save labels",
  "Sluit het issue": "Close the issue",
  "Heropen het issue": "Reopen the issue",
  "Label {label}, wis het filter": "Label {label}, clear the filter",
  "Nieuw issue": "New issue",
  "Issue maken": "Create issue",
  "Geen issues.": "No issues.",
  "Terug naar de pull requests": "Back to the pull requests",
  "De pull request kon niet worden geopend.": "The pull request could not be opened.",
  "De pull request kon niet worden gemaakt.": "The pull request could not be created.",
  "samengevoegd": "merged",
  "gesloten": "closed",
  "naar": "into",
  "Een van de twee takken bestaat niet meer.": "One of the two branches no longer exists.",
  "Geen beschrijving.": "No description.",
  "Sluit de pull request": "Close the pull request",
  "Heropen de pull request": "Reopen the pull request",
  "Open": "Open",
  "Gesloten": "Closed",
  "Nieuwe pull request": "New pull request",
  "Maak eerst een tak naast {hoofd}.": "Create a branch next to {hoofd} first.",
  "Naar": "Into",
  "Titel": "Title",
  "Beschrijving": "Description",
  "Pull request maken": "Create pull request",
  "Geen pull requests.": "No pull requests.",
  "beschermd": "protected",
  "Alleen een samengevoegde pull request verandert deze tak, na jouw bevestiging.": "Only a merged pull request changes this branch, after your confirmation.",
  "Tak {naam} gemaakt.": "Branch {naam} created.",
  "De tak kon niet worden gemaakt.": "The branch could not be created.",
  "Tak {naam} verwijderd.": "Branch {naam} deleted.",
  "De tak kon niet worden verwijderd.": "The branch could not be deleted.",
  "Vergelijken lukte niet.": "Comparing did not work.",
  "Naam van de nieuwe tak": "Name of the new branch",
  "vanaf": "from",
  "Vanaf welke tak": "From which branch",
  "Tak maken": "Create branch",
  "standaard": "default",
  "Vergelijk": "Compare",
  "Verwijder tak {naam}": "Delete branch {naam}",
  "Zeker weten?": "Are you sure?",
  "{voor} voor, {achter} achter": "{voor} ahead, {achter} behind",
  "Deze tak heeft geen vastleggingen die {basis} nog niet heeft.": "This branch has no commits that {basis} does not have yet.",
  "Persona EN": "Persona EN",
  "Persona NL": "Persona NL",
  "Persona": "Persona",
  "Hoe NovaMund klinkt en zichzelf beschrijft. Nooit wat het antwoord inhoudelijk is.": "How NovaMund sounds and describes itself. Never what an answer says.",
  "Naam in de eerste zin (vast): {naam}": "Name in the first sentence (fixed): {naam}",
  "{n} van {max} woorden": "{n} of {max} words",
  "De naam {naam} hoort in de eerste zin.": "The name {naam} belongs in the first sentence.",
  "Kosmische laag": "Cosmic layer",
  "Uit: de eerste en de laatste alinea gaan niet mee naar het model. De laatste regel blijft.": "Off: the first and the last paragraph are not sent to the model. The last line stays.",
  "Herstel standaard": "Restore default",
  "Persona opslaan": "Save persona",
  "Persona opgeslagen": "Persona saved",
  "Persona opslaan is mislukt": "Saving the persona failed",
  "Extra instructies": "Extra instructions",
  "Leeg laten kan. Wat hier staat, komt na de persona uit Merk.": "You can leave this empty. What you write here comes after the persona from Brand.",
  "De persona staat in Instellingen > Merk. Wat hier staat, komt erna als extra instructie; de vaste regels van NovaMund wegen zwaarder.": "The persona is in Settings > Brand. What you write here comes after it as an extra instruction; NovaMund's fixed rules weigh more.",
  "Geheugen": "Memory",
  "Wat Novamund over jou en je werk heeft geleerd, alleen op deze machine bewaard. Je kunt elke regel lezen en alles verwijderen.": "What Novamund has learned about you and your work, stored only on this machine. You can read every line and delete everything.",
  "Geheugen openen": "Open memory",
  "Toegang tot Claude, GPT-4, Llama en meer": "Access to Claude, GPT-4, Llama and more",
  "Betaal per token, geen abonnement": "Pay per token, no subscription",
  "100% privé: je gegevens verlaten je apparaat niet": "100% private: your data does not leave your device",
  "Geen API-kosten, werkt zonder internet": "No API costs, works without internet",
  "Werkt het best met een eigen GPU": "Works best with its own GPU",
  "Snelle, betrouwbare AI in de cloud": "Fast, reliable AI in the cloud",
  "Vraagt een API-sleutel en internet": "Needs an API key and internet",
  "LLM-raad: lokale leden": "LLM council: local members",
  "Kies de lokale modellen die in de raad zitten. Er zijn er minstens twee nodig voordat hij kan draaien. Vink niets aan om alleen het model te gebruiken waarmee je chat. Elk lid is een aparte aanroep, dus meer leden betekent langer wachten.": "Choose the local models that sit on the council. At least two are needed before it can run. Tick nothing to use only the model you chat with. Each member is a separate call, so more members means a longer wait.",
  "Geen lokale modellen gevonden. Ollama moet draaien om deze lijst te vullen.": "No local models found. Ollama has to be running to fill this list.",
  "Een model gekozen. De raad heeft er minstens twee nodig, of een API-sleutel van een andere aanbieder.": "One model chosen. The council needs at least two, or an API key from another provider.",
  "Webtoegang": "Web access",
  "Of Novamund een webpagina voor je mag ophalen. Standaard uit.": "Whether Novamund may fetch a web page for you. Off by default.",
  "Antwoord uit een tabelrij": "Answer from a table row",
  "Wijzigingen terugschrijven naar het bestand": "Write changes back to the file",
  "Hiermee bewerk je een document en schrijf je het terug naar het markdownbestand waar het vandaan kwam. Standaard uit.": "With this you edit a document and write it back to the markdown file it came from. Off by default.",
  "Temperatuur": "Temperature",
  "Binnen hetzelfde kwartier geeft dezelfde vraag hetzelfde antwoord; vraag je hoe laat het is, dan binnen dezelfde minuut. Daarna kan het verschillen, omdat elk antwoord de huidige tijd meekrijgt. Ook na een herstart kan het verschillen.": "Within the same quarter of an hour the same question gives the same answer; if you ask what time it is, within the same minute. After that it can differ, because every answer is given the current time. It can also differ after a restart.",
  "CLAW-browserveiligheid": "CLAW browser safety",
  "Waar hij heen mag als webtoegang aan staat. Gescheiden door komma's, en allebei optioneel: de schakelaar hierboven beslist of de assistent het internet uberhaupt bereikt.": "Where it may go when web access is on. Separated by commas, and both optional: the switch above decides whether the assistant reaches the internet at all.",
  "Toegestane domeinen (leeg = alle sites; vul dit alleen in als je wilt beperken waar hij heen mag)": "Allowed domains (empty = all sites; only fill this in if you want to limit where it may go)",
  "Geblokkeerde domeinen": "Blocked domains",
  "bijv. github.com, wikipedia.org": "e.g. github.com, wikipedia.org",
  "bijv. login.example.com, mail.google.com": "e.g. login.example.com, mail.google.com",
  "Sneltoetsen:": "Shortcuts:",
  "Zoeken •": "Search •",
  "Nieuwe chat •": "New chat •",
  "Instellingen •": "Settings •",
  "Zijbalk tonen of verbergen": "Show or hide the sidebar",
  "Deze versie": "This version",
  "Opslaan...": "Saving...",
  "Instellingen opslaan": "Save settings",
  "Voor vragen als \u201choeveel uur op DOQENT\u201d. Standaard aan.": "For questions like \u201chow many hours on DOQENT\u201d. On by default.",
  "Alles vergeten": "Forget everything",
  "Wat Novamund heeft geleerd en wat je het kunt laten vergeten. Het staat alleen op deze machine, versleuteld, en niets hiervan gaat de deur uit.": "What Novamund learned and can be asked to forget. It is stored on this machine only, encrypted, and nothing here leaves it.",
  "Voorstellen wat hij over je opmerkt": "Offer things it notices about you",
  "Afgeronde gesprekken teruglezen": "Look back over finished conversations",
  "Staat dit aan, dan wordt een afgerond gesprek een keer teruggelezen en komt wat steeds terugkomt in het blok Voorgesteld hierboven, met de citaten waarop het rust. Er zijn twee losse keren nodig voordat hij iets voorstelt, en hij stelt er per keer hooguit drie voor. Wat wacht blijft staan en verloopt niet, hoeveel het er ook zijn; zijn het er meer dan tien, dan meldt deze pagina bovenaan hoeveel. Er wordt niets bewaard tot jij het aanneemt, en wat je wegklikt komt nooit terug.": "When this is on, a finished conversation is read back once and anything it keeps running into is put in the Suggested block above, with the quotes it rests on. It needs two separate occurrences before it will suggest anything, and it proposes at most three at a time. What is waiting stays and never expires, however many there are; when more than ten are waiting, this page says how many at the top. Nothing is stored until you accept it, and what you dismiss is never suggested again.",
  "Lezen": "Reading",
  "Er is nog niets onthouden.": "Nothing is remembered yet.",
  "Alles vergeten?": "Forget everything?",
  "Laat staan": "Keep them",
  "Voorstellen wat te onthouden": "Offer things to remember",
  "Kon niet lezen wat er onthouden is": "Could not read what is remembered",
  "Kon dat niet wijzigen": "Could not change that",
  "Kon die niet aannemen": "Could not accept those",
  "Kon dat niet vergeten": "Could not forget that",
  "Onthouden": "Remembered",
  "Kon dat niet onthouden": "Could not remember that",
  "Weggeklikt, en het wordt niet opnieuw voorgesteld": "Dismissed, and it will not be suggested again",
  "Kon dat niet wegklikken": "Could not dismiss that",
  "Kon niet alles vergeten": "Could not forget everything",
  "Dit is precies wat er verstuurd wordt. Er kan niets anders uit.": "This is exactly what will be sent. Nothing else can go out.",
  "Terug naar bewerken": "Back to editing",
  "Schrijf je antwoord. Er gaat niets weg tot je het hebt teruggelezen.": "Write your reply. Nothing is sent until you have read it back.",
  "Postbus": "Inbox",
  "Er is nog niets opgeslagen. Kies de werkruimte.": "Nothing has been saved yet. Choose the workspace.",
  "Werkruimte": "Workspace",
  "aanmaken": "create",
  "bestaat nog niet, wordt aangemaakt": "does not exist yet, will be created",
  "Taak": "Task",
  "Toegewezen": "Assigned",
  "Wijzig": "Edit",
  "Taak aangemaakt in TASQ": "Task created in TASQ",
  "Afvinken": "Tick off",
  "Naar volgende werkdag": "To next working day",
  "Geen deadlines vandaag en geen achterstand.": "No deadlines today and nothing overdue.",
  "Maak taakvoorstel": "Make task proposal",
  "Geen open actiepunten sinds de vorige werkdag.": "No open action items since the previous working day.",
  "Geen afspraken vandaag.": "No appointments today.",
  "nieuw": "new",
  "Dit bericht is onleesbaar opgeslagen.": "This message was stored unreadable.",
  "Niet gekoppeld": "Not connected",
  "Kon er niet bij": "Could not reach it",
  "Blijft:": "Stays:",
  "Gaat weg:": "Goes:",
  "Samengevoegd. Er staat nu een regel.": "Merged. There is now one line.",
  "Vervangen. De oudere regel is weg.": "Replaced. The older line is gone.",
  "Een van de twee regels bestond niet meer; er is niets veranderd.": "One of the two lines no longer existed; nothing changed.",
  "Laten staan. Beide regels blijven, en dit paar komt niet terug.": "Left as is. Both lines stay, and this pair will not come back.",
  "Deze twee geleerde regels zeggen vrijwel hetzelfde. Samenvoegen houdt de bovenste.": "These two learned lines say almost the same thing. Merging keeps the top one.",
  "De bovenste, nieuwere regel lijkt de onderste te hebben ingehaald. Vervangen haalt de onderste weg.": "The top, newer line seems to have overtaken the bottom one. Replacing removes the bottom one.",
  "Voeg samen": "Merge",
  "Vervang": "Replace",
  "Verstuurd": "Sent",
  "Staat dit aan, dan wordt een voorkeur die je terloops noemt aan je voorgelegd om aan te nemen of te negeren. Er wordt nooit iets over je bewaard zonder dat je het zegt. Zeggen \u201conthoud dat ...\u201d werkt hoe dan ook, want dan vraag jij het.": "When this is on, a preference you mention in passing is offered back for you to accept or ignore. Nothing is ever stored about you without you saying so. Telling it \u201cremember that ...\u201d works either way, because that is you asking.",
  "Het opstellen is niet gelukt": "Drafting failed",
  "Het versturen is niet gelukt": "Sending failed",
  "dit is nu bij de ontvanger en kan niet worden teruggehaald.": "this is with the recipient now and cannot be taken back.",
  "Het voorstel is niet op te halen": "The proposal could not be fetched",
  "Het aanmaken is niet gelukt": "Creating it failed",
  "De postbus kon niet worden opgehaald.": "The inbox could not be fetched.",
  "Het voorstel kon niet worden gemaakt.": "The proposal could not be made.",
  "Het voorstel kon niet worden geopend.": "The proposal could not be opened.",
  "Er ging iets mis; er is niets veranderd.": "Something went wrong; nothing changed.",
  "Dit over je onthouden?": "Remember this about you?",
  "Onthoud het": "Remember it",
  "Nee, dank je": "No thanks",
  "Er is nog niets gewijzigd. Kies de taak.": "Nothing has been changed yet. Choose the task.",
  "Deadline": "Deadline",
  "Taak gewijzigd in TASQ": "Task changed in TASQ",
  "De wijziging is niet op te halen": "The change could not be fetched",
  "De wijziging is niet doorgevoerd": "The change was not carried out",
  "Deze taak lukte en is gecontroleerd. Wil je de aanpak bewaren als skill? Er gebeurt niets tot je kiest.": "This task succeeded and was checked. Do you want to keep the approach as a skill? Nothing happens until you choose.",
  "Taak:": "Task:",
  "Naam": "Name",
  "Instructies": "Instructions",
  "Niet nodig": "Not needed",
  "Niet nodig. Er is geen skill gemaakt.": "Not needed. No skill was created.",
  "Er ging iets mis; er is niets besloten.": "Something went wrong; nothing was decided.",
  "Open in TASQ": "Open in TASQ",
  "Weiger": "Decline",
  "Doorgevoerd in TASQ.": "Carried out in TASQ.",
  "Geweigerd. Er is niets gewijzigd.": "Declined. Nothing was changed.",
  "reden onbekend": "reason unknown",
  "Opgeslagen als document": "Saved as a document",
  "Bekijk het onder Knowledge": "See it under Knowledge",
  "Bekijk of vergeet het in Geheugen": "See or forget it in Memory",
  "Er is niets onthouden": "Nothing was remembered",
  "Zeg het als \"Onthoud dat ...\" of \"Leg dit vast\" met de tekst eronder, dan sla ik het op.": "Say it as \"Remember that ...\" or \"Save this\" with the text below it, and I will store it.",
  "Dat klonk alsof je wilde dat ik iets onthield, maar ik heb niets opgeslagen.": "That sounded as if you wanted me to remember something, but I stored nothing.",
  "Voorgesteld": "Suggested",
  "Opgemerkt, niet bewaard. Niets hiervan wordt in een antwoord gebruikt tot je het aanneemt.": "Noticed, not stored. Nothing here is used in an answer until you accept it.",
  "Voorgestelde herinneringen": "Suggested memories",
  "Verberg waarom": "Hide why",
  // Herstel Geheugen NL, 21 oktober 2026: het blok Voorgesteld en de herkomstregel.
  "Waarom ({aantal})": "Why ({aantal})",
  "{aantal} wachtend": "{aantal} waiting",
  "Neem alle {aantal} aan": "Accept all {aantal}",
  "{aantal} keer gezien": "seen {aantal} times",
  "Herschrijf voor het onthouden: {tekst}": "Rewrite before remembering: {tekst}",
  "Onthoud: {tekst}": "Remember: {tekst}",
  "Nee, stel dit nooit meer voor: {tekst}": "No thanks, never suggest again: {tekst}",
  "je vroeg me het te onthouden": "you asked me to remember it",
  "iets wat je zei": "something you said",
  "je keurde dit goed op {datum}": "you approved this on {datum}",
  "agentrun van {pad}": "agent run of {pad}",
  "run van {pad}": "run of {pad}",
  "gesprek {id}": "conversation {id}",
  "Zoek overal": "Search everywhere",
  // Oogstbewaking, 21 oktober 2026.
  "De laatste oogst is mislukt op {datum}": "The last harvest failed on {datum}",
  "Reden: {reden}": "Reason: {reden}",
  "De reden is niet bewaard.": "The reason was not kept.",
  "De oogst heeft sinds {datum} niets meer geleerd": "The harvest has learned nothing since {datum}",
  "De oogst heeft nog niets geleerd": "The harvest has not learned anything yet",
  "{aantal} voorstellen wachten op je": "{aantal} suggestions are waiting for you",
  "Neem ze aan of klik ze weg wanneer het je uitkomt; de oogst gaat gewoon door en er verloopt niets.": "Accept or dismiss them whenever it suits you; the harvest carries on and nothing expires.",
  "De oogst leest alleen met het lokale model. Kies Ollama in Instellingen.": "The harvest only reads with the local model. Choose Ollama in Settings.",
  "De oogstklok staat uit in deze installatie.": "The harvest clock is switched off in this installation.",
  "De oogstklok heeft meer dan 24 uur geen ronde gedraaid. Start NovaMund opnieuw.": "The harvest clock has not run a round for more than 24 hours. Restart NovaMund.",
  "Laat je werk zien": "Show your work",
  "uit": "from",
  "je bronnen": "your sources",
  "Gedeeltelijk oordeel": "Partial verdict",
  "Rechter is een lid": "Judge is a member",
  "Losse antwoorden": "Individual answers",
  "Voor dit antwoord is geen spoor opgeslagen.": "No action trail recorded for this answer.",
  "Exporteren": "Export",
  "Beantwoorden": "Reply",
  "Er was geen model buiten de raad beschikbaar, dus een lid van de raad beoordeelde ook zijn eigen antwoord.": "No non-participating model was available, so a council member judged its own answer too.",
  "Het spoor kon niet worden geladen": "Failed to load action trail",
  "Het spoor kon niet worden geëxporteerd": "Failed to export trail",
  "Gekopieerd": "Copied to clipboard",
  "Kopiëren mislukt": "Failed to copy",
  "Doorgezet naar": "Escalated to",
  "Verstuurd naar": "Sent to",
  "Op deze Mac": "On this Mac",
  "Een back-up kan alleen in de app op de Mac, want de sleutel staat in de sleutelbos van de Mac.": "A backup is only possible in the app on the Mac, because the key is in the Mac's keychain.",
  "Er is nog geen PQC-sleutel. Maak er een in het blok PQC-sleutel hieronder en exporteer hem; daarna kun je een back-up maken.": "There is no PQC key yet. Make one in the PQC key block below and export it; then you can make a backup.",
  "Je PQC-sleutel is nog niet geëxporteerd. Exporteer hem in het blok PQC-sleutel hieronder; zonder export is een back-up niet terug te zetten.": "Your PQC key has not been exported yet. Export it in the PQC key block below; without an export a backup cannot be restored.",
  "De sleutel-export hoort niet bij je sleutel. Exporteer hem opnieuw in het blok PQC-sleutel hieronder.": "The key export does not belong to your key. Export it again in the PQC key block below.",
  "Naar het blok PQC-sleutel": "To the PQC key block",
  "Alleen een eigenaar kan de PQC-sleutel beheren.": "Only an owner can manage the PQC key.",
  "Dat is niet gelukt. Probeer het opnieuw, of kijk of dit de app op de Mac is.": "That did not work. Try again, or check that this is the app on the Mac.",
  "PQC-sleutel": "PQC key",
  "Je eigen sleutel voor versleutelde back-ups en versleutelde opslag. Hij staat in de sleutelbos van deze Mac; de export is een bestand dat je buiten deze Mac bewaart.": "Your own key for encrypted backups and encrypted storage. It is in this Mac's keychain; the export is a file you keep outside this Mac.",
  "Een PQC-sleutel kan alleen in de app op de Mac, want hij staat in de sleutelbos van de Mac.": "A PQC key is only possible in the app on the Mac, because it lives in the Mac's keychain.",
  "Stap 1 van 2: er is nog geen sleutel. Maak er een; een bestaande sleutel wordt nooit vervangen.": "Step 1 of 2: there is no key yet. Make one; an existing key is never replaced.",
  "Sleutel maken": "Make key",
  "Vingerafdruk": "Fingerprint",
  "Stap 2 van 2: exporteer de sleutel. Zonder export is een back-up niet terug te zetten als deze Mac weg is.": "Step 2 of 2: export the key. Without an export a backup cannot be restored if this Mac is gone.",
  "Sleutel exporteren": "Export key",
  "Export geschreven naar": "Export written to",
  "Bewaar dit bestand op een veilige plek buiten deze Mac: wie het kwijt is, is alles kwijt wat ermee versleuteld is.": "Keep this file in a safe place outside this Mac: whoever loses it loses everything encrypted with it.",
  "De sleutel is geëxporteerd; een back-up kan nu.": "The key has been exported; a backup is possible now.",
  "PQC-versleuteling": "PQC encryption",
  "Over": "About",
  "Deze bouw heeft geen SBOM. Die maakt de bouwstap bij het bouwen van de app.": "This build has no SBOM. The build step makes it when the app is built.",
  "componenten": "components",
  "Deze SBOM hoort bij versie": "This SBOM belongs to version",
  "SBOM downloaden": "Download SBOM",
  "Keten geverifieerd": "Chain verified",
  "Keten gebroken": "Chain broken",
  "Deels zonder keten": "Partly without a chain",
  "Geen sporen in deze periode": "No trails in this period",
  "De vluchtrecorder exporteren is mislukt.": "Exporting the flight recorder failed.",
  "Vluchtrecorder": "Flight recorder",
  "Alle sporen van deze werkruimte in een periode, als JSON, met de ketencontrole samengevat. Beide dagen tellen mee.": "All trails of this workspace in a period, as JSON, with the chain check summarised. Both days are included.",
  "Van": "From",
  "Tot en met": "Up to and including",
  "Exporteer vluchtrecorder": "Export flight recorder",
  "Kies een begin dat niet na het einde ligt.": "Choose a start that is not after the end.",
  "sporen in": "trails in",
  "gesprekken": "conversations",
  "geverifieerd": "verified",
  "gebroken": "broken",
  "zonder keten": "without a chain",
  "Exporteren is mislukt.": "Exporting failed.",
  "Export": "Export",
  "Een zip met je eigen werk in open formaat: gesprekken als JSON en Markdown, projecten, kennisbankdocumenten, geheugen, agents en skills als JSON. Er staan geen sleutels of wachtwoorden in.": "A zip with your own work in an open format: conversations as JSON and Markdown, projects, knowledge base documents, memory, agents and skills as JSON. No keys or passwords are included.",
  "Bezig met exporteren...": "Exporting...",
  "Exporteer deze werkruimte": "Export this workspace",
  "Exporteer alles": "Export everything",
  "Export klaar": "Export ready",
  "Er loopt al een back-up.": "A backup is already running.",
  "Alleen een eigenaar kan een back-up maken.": "Only an owner can make a backup.",
  "Back-up maken is mislukt.": "Making the backup failed.",
  "Herstel-test geslaagd": "Restore test passed",
  "Herstel-test mislukt": "Restore test failed",
  "Herstel-test onbekend": "Restore test unknown",
  "Back-up": "Backup",
  "Een versleutelde back-up van je database, vectoren, werkruimtes en instellingen, met je eigen PQC-sleutel. Daarna opent een herstel-test hem met je sleutel-export in een wegwerpmap; je echte database wordt niet aangeraakt.": "An encrypted backup of your database, vectors, workspaces and settings, with your own PQC key. A restore test then opens it with your key export in a throwaway folder; your real database is not touched.",
  "Bezig met de back-up...": "Making the backup...",
  "Back-up maken": "Make backup",
  "Integriteit": "Integrity",
  "in orde": "ok",
  "Tellingen per tabel": "Counts per table",
  "gelijk": "equal",
  "niet gelijk": "not equal",
  "Nog geen back-ups.": "No backups yet.",
  "bestand gewijzigd sinds het maken": "file changed since it was made",
  "Data": "Data",
  "Dropbox als opslag": "Dropbox as storage",
  "Aan: NovaMund leest en schrijft in je Dropbox-mappen.": "On: NovaMund reads and writes in your Dropbox folders.",
  "Uit: NovaMund leest en schrijft niets in een Dropbox-map. Kennisbanken daar worden overgeslagen; er wordt niets verwijderd.": "Off: NovaMund reads and writes nothing in a Dropbox folder. Knowledge bases there are skipped; nothing is deleted.",
  "Alleen een eigenaar kan Dropbox aan of uit zetten.": "Only an owner can turn Dropbox on or off.",
  "Dropbox aan of uit zetten is mislukt.": "Turning Dropbox on or off failed.",
  "Alleen in de database": "Only in the database",
  "Het dataoverzicht kon niet worden geladen.": "The data overview could not be loaded.",
  "Waar je gegevens staan, per stroom. Dit overzicht leest alleen.": "Where your data is, per stream. This overview only reads.",
  "Database": "Database",
  "Vault (basismap)": "Vault (base folder)",
  "Geen kennisbanken.": "No knowledge bases.",
  "Vectoren": "Vectors",
  "Back-ups": "Backups",
  "Modelaanroepen": "Model calls",
  "Nog geen aanbieder gekozen.": "No provider chosen yet.",
  "account": "account",
  "agents": "agents",
  "Schakelaars": "Switches",
  "PQC-versleuteling staat aan.": "PQC encryption is on.",
  "PQC-versleuteling staat uit.": "PQC encryption is off.",
  "Aan of uit zetten doe je onder Meer.": "You turn it on or off under More.",
  "Kennisbanken met synchronisatie uit": "Knowledge bases with sync off",
  "Per kennisbank te zetten bij Kennis.": "Set per knowledge base under Knowledge.",
  "Buiten de EU": "Outside the EU",
  "Locatie onbekend": "Location unknown",
  "Locatie": "Location",
  "Nieuwe chat aanmaken mislukt": "Failed to create new chat",
  "Gesprekken laden mislukt": "Failed to load conversations",
  "Gesprek verwijderd": "Conversation deleted",
  "Gesprek verwijderen mislukt": "Failed to delete conversation",
  "Gesprek hernoemd": "Conversation renamed",
  "Gesprek hernoemen mislukt": "Failed to rename conversation",
  "Gesprek exporteren mislukt": "Failed to export conversation",
  "Project aangemaakt": "Project created",
  "Project aanmaken mislukt": "Failed to create project",
  "Model bijgewerkt": "Model updated",
  "Model bijwerken mislukt": "Failed to update model",
  "Stel eerst je API-sleutel in": "Please configure your API key first",
  "Voor nu genoteerd, maar deze kan terugkomen: het opslaan van je nee lukte niet": "Noted for now, but this one may come back: saving the no failed",
  "De handeling is mislukt": "Action execution failed",
  "Handeling uitgevoerd": "Action completed",
  "De handeling kon niet worden uitgevoerd": "Failed to execute action",
  "Instellingen opgeslagen": "Settings saved",
  "Pas de regel aan in Instellingen als dit niet was wat je wilde.": "Change the policy in Settings if this was not what you wanted.",
  "Uit het project gehaald": "Taken out of the project",
  "Bericht versturen mislukt": "Failed to send message",
  "Tegengehouden door je routeringsregel": "Blocked by your routing policy",
  "De orkestratie is mislukt": "Orchestration failed",
  "Het gesprek kon niet worden aangemaakt.": "The conversation could not be created.",
  "Stoppen lukte niet; het antwoord loopt nog.": "Stopping failed; the answer is still running.",
  "Het bericht kon niet worden verstuurd.": "The message could not be sent.",
  "Een nieuw universum van intelligentie": "A new universe of intelligence",
  "Welkom terug": "Welcome back",
  "Meld je aan bij je Novamund-account": "Sign in to your Novamund account",
  "Een moment...": "One moment...",
  "Deze telefoon is nog niet verbonden met je computer.": "This phone is not connected to your computer yet.",
  "Novamund draait op je eigen machine, dus hier valt niets aan te melden tot de twee verbonden zijn. Open Novamund op je computer en scan de code die hij toont. Daarna meld je je zoals altijd aan met SPEAQ ID of je wachtwoord.": "Novamund runs on your own machine, so there is nothing here to sign in to until the two are joined. Open Novamund on your computer, then scan the code it shows. After that you can sign in with SPEAQ ID or your password as usual.",
  "Scan de code op je computer": "Scan the code on your computer",
  "E-mail": "Email",
  "Wachtwoord": "Password",
  "Kijk in je mail voor de herstelinstructies": "Check your email for reset instructions",
  "Wachtwoord vergeten?": "Forgot password?",
  "Doorgaan met Google": "Continue with Google",
  "Registreren": "Register",
  "Licentie": "Licence",
  "{niveau}, geldig tot {datum}.": "{niveau}, valid until {datum}.",
  "{niveau}, zonder verloopdatum.": "{niveau}, with no expiry date.",
  "{niveau} is verlopen op {datum}. Nog {dagen} dagen respijt, tot {tot}; daarna werkt deze installatie als Free.": "{niveau} expired on {datum}. {dagen} days of grace left, until {tot}; after that this installation runs as Free.",
  "{niveau} is verlopen op {datum}; deze installatie werkt als Free.": "{niveau} expired on {datum}; this installation runs as Free.",
  "Geen organisatielicentie: elk account houdt zijn eigen plan.": "No organisation licence: every account keeps its own plan.",
  "De licentie kon niet worden gelezen.": "The licence could not be read.",
  "De licentie geldt voor iedereen in deze organisatie.": "The licence applies to everyone in this organisation.",
  "Licentiebestand activeren": "Activate licence file",
  "Alleen een eigenaar kan een licentie activeren.": "Only an owner can activate a licence.",
  "Licentie geactiveerd voor de hele organisatie.": "Licence activated for the whole organisation.",
  "Dit licentiebestand is niet geldig. Er is niets gewijzigd.": "This licence file is not valid. Nothing was changed.",
  "Nog geen account?": "Don't have an account?",
  "Aan de slag": "Get Started",
  // GL212-7: het welkomstscherm, de vijf knoppen en hun voorbeelden.
  "Strategie": "Strategize",
  "Maak klantreizen": "Create customer journeys",
  "Analyseer bedrijfscijfers": "Analyze business metrics",
  "Ontwikkel een zakelijk ecosysteem": "Develop a business ecosystem",
  "Maak leveranciersbeoordelingen": "Create vendor evaluations",
  "Ontwikkel risicoanalyses": "Develop risk assessments",
  "Creëren": "Create",
  "Bedenk creatieve ideeën": "Generate creative ideas",
  "Ontwerp een nieuw productconcept": "Design a new product concept",
  "Maak een marketingcampagne": "Create a marketing campaign",
  "Zet een opzet voor een presentatie op": "Build a presentation outline",
  "Schrijf berichten voor sociale media": "Draft social media content",
  "Schrijven": "Write",
  "Schrijf een zakelijke e-mail": "Write a professional email",
  "Schrijf een blogbericht": "Draft a blog post",
  "Maak documentatie": "Create documentation",
  "Schrijf een motivatiebrief": "Write a cover letter",
  "Schrijf een toespraak": "Compose a speech",
  "Leren": "Learn",
  "Leg een ingewikkeld begrip uit": "Explain a complex concept",
  "Vat een onderwerp samen": "Summarize a topic",
  "Maak een studiegids": "Create a study guide",
  "Vergelijk verschillende aanpakken": "Compare different approaches",
  "Geef leerbronnen": "Provide learning resources",
  "Zoek de fout in deze code": "Debug this code",
  "Leg deze functie uit": "Explain this function",
  "Schrijf unittests": "Write unit tests",
  "Herschrijf voor betere prestaties": "Refactor for performance",
  "Maak een API-endpoint": "Create an API endpoint",
  "Stel je API-sleutel in of gebruik Ollama voor lokale modellen.": "Configure your API key or use Ollama for local models.",
  "Aanbieder instellen": "Configure Provider",
  "Doorgaan zonder account": "Continue without account",
  "jij@voorbeeld.nl": "you@example.com",
  "Aangemeld": "Signed in",
  "Vul eerst je e-mailadres in": "Enter your email first",
  "Herstellink verstuurd als het adres bestaat": "Reset link sent if email exists",
  "Herstelmail versturen mislukt": "Failed to send reset email",
  "Wachtwoord verbergen": "Hide password",
  "Wachtwoord tonen": "Show password",
  "Aanmelden...": "Signing in...",
  "Aanmelden": "Sign in",
  "Aanmelden mislukt": "Failed to sign in",
  "Account aanmaken": "Create account",
  "Begin met Novamund": "Get started with Novamund",
  "Weergavenaam": "Display Name",
  "Al een account?": "Already have an account?",
  "Je naam": "Your name",
  "Account aangemaakt": "Account created",
  "Aanmaken...": "Creating...",
  "Account aanmaken mislukt": "Failed to create account",
  "Wachtwoord herstellen": "Reset password",
  "Vul je nieuwe wachtwoord in": "Enter your new password",
  "Nieuw wachtwoord": "New Password",
  "Wachtwoord bevestigen": "Confirm Password",
  "Terug naar aanmelden": "Back to sign in",
  "De wachtwoorden zijn niet gelijk": "Passwords do not match",
  "Het wachtwoord moet minstens 6 tekens hebben": "Password must be at least 6 characters",
  "Wachtwoord hersteld": "Password reset successful",
  "Herstellen...": "Resetting...",
  "Wachtwoord herstellen mislukt": "Failed to reset password",
  "Geëxporteerd als {f}": "Exported as {f}",
  "Verplaatst naar {naam}": "Moved to {naam}",
  "Onthouden: {tekst}": "Remembered: {tekst}",
  // Van de dienst: backend/services/live.py VERVANGEN. Moet letterlijk gelijk blijven.
  "Na de controles is dit antwoord aangepast; je ziet nu de nagekeken versie.": "After the checks this answer was adjusted; you are now seeing the checked version.",
  // Van de dienst: backend/services/live.py TAAL_GEZET (GL214-8). Moet letterlijk gelijk blijven.
  "In het Nederlands gezet": "Put into Dutch",
  // GL215 S2: het dossier.
  "Dossier (zip)": "Dossier (zip)",
  "Dossier gedownload": "Dossier downloaded",
  "Dossier maken mislukt": "Could not make the dossier",
  "Dossier nakijken": "Check a dossier",
  "Kies een dossier (zip) uit het menu bij een gesprek. Elk bestand wordt tegen het manifest gelegd.": "Choose a dossier (zip) from the menu of a conversation. Every file is checked against the manifest.",
  "Nakijken is mislukt.": "Checking failed.",
  "ontbreekt": "missing",
  "erbij gekomen": "added",
  "In het Engels gezet": "Put into English",
  "Agenten": "Agents",
  "Geen passende agent": "No matching agent",
  "Toont je agenda van vandaag, of van de dag die je erachter zet": "Shows your calendar for today, or for the day you put after it",
  "Toont je recente gespreksverslagen uit Fathom": "Shows your recent meeting notes from Fathom",
  "Toont je recente bestanden in Google Drive": "Shows your recent files in Google Drive",
  "Nieuwe agent": "New Agent",
  "vroeg:": "asked:",
  "Beantwoord het": "Answer it",
  "Nog geen agenten. Een agent draagt zijn eigen opdracht, skills en kennis, zodat een run volgende week hetzelfde leest.": "No agents yet. An agent carries its own brief, skills and knowledge, so a run of it reads the same next week.",
  "Kies een agent": "Select an agent",
  "Bewerken": "Edit",
  "Geen. Hij werkt alleen vanuit zijn opdracht.": "None. It works from its brief alone.",
  "Geen. Hij werkt met wat jij hem geeft.": "None. It works from what you give it.",
  "Een bank is niet meer voor je beschikbaar": "One base is no longer available to you",
  "Hij stopte en vroeg je iets": "It stopped and asked you something",
  "Hij gaat verder in dezelfde run, met alles wat hij al had.": "It carries on in this same run, with everything it already had.",
  "Opdracht": "Brief",
  "Vaste taak": "Standing task",
  "Wat dit account gebruikt": "Whatever this account uses",
  "Standaard voor deze aanbieder": "Default for this provider",
  "Deze agent blijft op deze machine.": "This agent stays on this machine.",
  "Leeg betekent dat hij je accountinstelling volgt, waar die ook naar wijst, ook als je hem later wijzigt.": "Empty means it follows your account setting, wherever that points, including when you change it later.",
  "Rondes": "Rounds",
  "Haal er een paar op het scherm Skills": "Get some on the Skills screen",
  "Gereedschap": "Tools",
  "Wat dit gereedschap leest blijft op deze machine, omdat het model dat ook doet.": "What these tools read stays on this machine, because the model does.",
  "Verder is niets bereikbaar: geen netwerk, geen bestanden, geen geheugen. Gereedschap dat hier niet is aangevinkt wordt in de code geweigerd, ook als de opdracht erom vraagt.": "Nothing else is reachable: no network, no files, no memory. A tool not ticked here is refused in code even if the brief asks for it.",
  "Kennisbanken": "Knowledge bases",
  "Maak er een op het scherm Knowledge": "Make one on the Knowledge screen",
  "Wat moet hij doen?": "What should it do?",
  "Je antwoord": "Your answer",
  "Antwoord op de vraag van de agent": "Answer to the agent's question",
  "bijv. Verslaggever": "e.g. Reporter",
  "Waar deze agent voor is. Hij vervangt je persona zolang hij draait.": "What this agent is for. It replaces your persona while it runs.",
  "Optioneel. Wat hij doet als je hem zonder iets start.": "Optional. What it does when you start it with nothing.",
  "Optioneel. Leeg betekent het standaardmodel.": "Optional. Empty means the default model.",
  "Agent opgeslagen": "Agent saved",
  "Agent aangemaakt": "Agent created",
  "Agent verwijderd": "Agent deleted",
  "Deze agent kon niet worden verwijderd": "Could not delete this agent",
  "Documenten opsommen": "List documents",
  "Kennis doorzoeken": "Search knowledge",
  "Een run is gestopt en wacht op je antwoord": "One run stopped and is waiting for your answer",
  "Deze agent heeft geen vaste taak, dus geef hem iets te doen.": "This agent has no standing task, so give it something to do.",
  "Agent bewerken": "Edit Agent",
  "Een ronde. Hij antwoordt een keer, en er wordt achteraf niets nagekeken.": "One round. It answers once, and nothing is checked afterwards.",
  "Opslaan": "Save",
  "Aanmaken": "Create",
  "Het antwoord kwam niet aan bij de run": "The answer did not reach the run",
  "Deze agent kon niet worden opgeslagen": "Could not save this agent",
  "De run is niet afgemaakt": "The run did not finish",
  "Vraagt geen gereedschap.": "Requests no tools.",
  "Gereedschap:": "Tools:",
  "Toegang nakijken": "Review access",
  "Importeren": "Import",
  "Skill smeden": "Forge Skill",
  "Galaxy-catalogus": "Galaxy Catalog",
  "Breid je AI uit met losse skills. Installeer met een klik, of smeed je eigen.": "Extend your AI with modular skills. Install with one click, or forge your own.",
  "Geïnstalleerd": "Installed",
  "Nog geen skills geïnstalleerd. Installeer er een uit de Galaxy-catalogus of smeed je eigen.": "No skills installed yet. Install one from the Galaxy catalog or forge your own.",
  "Omschrijving": "Description",
  "Categorie": "Category",
  "Deze skill is door iemand anders geschreven. Zolang hij aan staat, kan de assistent alleen het gereedschap gebruiken dat je hier goedkeurt. De rest blijft onbereikbaar.": "This skill was written by someone else. While it is enabled, the assistant can only use the tools you approve here. Everything else stays unavailable.",
  "Deze skill vraagt geen gereedschap.": "This skill does not ask for any tools.",
  "Toegang opslaan": "Save access",
  "SKILL.md importeren": "Import SKILL.md",
  "Kies een SKILL.md-bestand, of plak er een hieronder. Het formaat wordt gedeeld met ander agentgereedschap, dus een skill van elders komt ongewijzigd binnen.": "Pick a SKILL.md file, or paste one below. The format is shared with other agent tools, so a skill written elsewhere imports unchanged.",
  "SKILL.md-bestand kiezen": "Choose SKILL.md file",
  "Geplakte tekst importeren": "Import pasted text",
  "SKILL.md exporteren": "Export SKILL.md",
  "Delen op het P2P-netwerk": "Share to P2P network",
  "bijv. Offerteschrijver": "e.g. Proposal Writer",
  "Een regel: wat doet deze skill?": "One line: what does this skill do?",
  "algemeen": "general",
  "De instructies die het model volgt als deze skill aan staat...": "The instructions the model follows when this skill is enabled...",
  "Skills laden mislukt": "Failed to load skills",
  "Skill geïnstalleerd": "Skill installed",
  "Skill bijwerken mislukt": "Failed to update skill",
  "Skill verwijderd": "Skill removed",
  "Skill verwijderen mislukt": "Failed to remove skill",
  "Exporteren mislukt": "Export failed",
  "Skill bijgewerkt": "Skill updated",
  "Skill gesmeed": "Skill forged",
  "Skill geïmporteerd": "Skill imported",
  "Toegang tot gereedschap bijgewerkt": "Tool access updated",
  "Deze skill is door iemand anders geschreven. Zijn herkomst is niet nagekeken.": "This skill was written by someone else. Its origin is not verified.",
  "Goedgekeurd": "Approved",
  "Gevraagd maar niet goedgekeurd": "Requested but not approved",
  "Installeren": "Install",
  "Skill bewerken": "Edit Skill",
  "Een nieuwe skill smeden": "Forge a New Skill",
  "Wijzigingen opslaan": "Save changes",
  "Installeren mislukt": "Install failed",
  "Delen mislukt": "Share failed",
  "Opslaan mislukt": "Save failed",
  "Importeren mislukt": "Import failed",
  "Toegang bijwerken mislukt": "Failed to update access",
  "de namen van de bestanden in de kennisbanken op deze kaart": "the names of the files in the knowledge bases on this card",
  "hooguit drie passages uit diezelfde kennisbanken, per zoekopdracht": "up to three passages from those same knowledge bases, per search",
  "leest": "reads",
  "Draait op": "Runs on",
  "dit account": "this account",
  "en dat is buiten deze machine": "which is off this machine",
  "Nieuwe kennisbank": "New knowledge base",
  "Bevat": "Contains",
  "Algemeen": "General",
  "Hier staat nog niets. Een algemene kennisbank telt mee in elk gesprek.": "Nothing here yet. A general knowledge base counts in every conversation.",
  "Projecten": "Projects",
  "Nog geen kennisbanken bij een project.": "No knowledge bases with a project yet.",
  "Kies een kennisbank": "Choose a knowledge base",
  "Automatisch bijwerken uit": "Automatic updating off",
  "Automatisch bijwerken aan": "Automatic updating on",
  "Een PDF zonder tekst is bijna altijd een scan. Van deze bestanden is niets opgeslagen, dus een vraag over wat erin staat kan deze kennisbank niet beantwoorden.": "A PDF without text is almost always a scan. Nothing from these files was stored, so a question about what is in them cannot be answered by this knowledge base.",
  "Bestandsnaam": "File name",
  "Soort": "Type",
  "Grootte": "Size",
  "Stukken": "Chunks",
  "Nog geen documenten. Upload bestanden om ze te indexeren.": "No documents yet. Upload files to index them.",
  "zet terug": "put back",
  "Opgeknipt met een geschatte tokentelling, dus de stukken hebben mogelijk niet de bedoelde grootte.": "Split with an estimated token count, so the chunks may not have the intended size.",
  "bijv. Projectdocumenten": "e.g. Project documents",
  "Optioneel": "Optional",
  "Nieuwe algemene kennisbank": "New general knowledge base",
  "Map met notities, bijvoorbeeld /Users/jij/Vault": "Folder with notes, for example /Users/you/Vault",
  "Zoek in deze kennisbank…": "Search this knowledge base…",
  "Kennisbank bijgewerkt": "Knowledge base updated",
  "Kennisbank aangemaakt": "Knowledge base created",
  "Kennisbank verwijderd": "Knowledge base deleted",
  "Verwijderen is mislukt": "Deleting failed",
  "Document verwijderd": "Document deleted",
  "Zoeken is mislukt": "Search failed",
  "Opslaan is mislukt": "Saving failed",
  "Aanmaken is mislukt": "Creating failed",
  "Automatisch bijwerken staat uit voor deze kennisbank": "Automatic updating is off for this knowledge base",
  "Automatisch bijwerken staat aan voor deze kennisbank": "Automatic updating is on for this knowledge base",
  "Telt mee in elk gesprek": "Counts in every conversation",
  "Kennisbank bewerken": "Edit knowledge base",
  "Kennisbank aanmaken": "Create knowledge base",
  "Wordt niet doorzocht in gesprekken. Een agent die deze kennisbank noemt, krijgt een tweede beurt die zijn antwoord in deze vorm giet.": "Not searched in conversations. An agent that names this knowledge base gets a second turn that pours its answer into this form.",
  "Wordt bij elk gesprek doorzocht, in dit project of overal, afhankelijk van waar hij hangt.": "Searched in every conversation, in this project or everywhere, depending on where it hangs.",
  "Uploaden is mislukt": "Uploading failed",
  "Importeren is mislukt": "Importing failed",
  "Opnieuw indexeren is mislukt": "Reindexing failed",
  "Automatisch bijwerken kon niet worden omgezet": "Automatic updating could not be switched",
  "Terugzetten is mislukt": "Putting back failed",
  "Geen omschrijving": "No description",
  "Nieuw": "New",
  "Laden…": "Loading…",
  "Nog geen werkruimtes": "No workspaces yet",
  "Een werkruimte is een map waarin code kan draaien zonder iets anders op deze machine te raken. Geen netwerk, tenzij jij het toestaat.": "A workspace is a folder where code can run without touching anything else on this machine. No network, unless you allow it.",
  "Maak er een": "Make one",
  "Bestanden": "Files",
  "Nieuw bestand": "New file",
  "boven": "up",
  "Nog niets. Typ hieronder een bestandsnaam, bijvoorbeeld hallo.py.": "Nothing yet. Type a file name below, for example hello.py.",
  "Wat deze werkruimte de agent leerde": "What this workspace taught the agent",
  "Wat de agent deed": "What the agent did",
  "Wat er gebeurde": "What happened",
  "Opdracht voor de agent: hij schrijft de bestanden en voert ze zelf uit": "Task for the agent: it writes the files and runs them itself",
  "Stop": "Stop",
  "Terug naar de chat": "Back to the chat",
  "Terug naar de werkruimtes": "Back to the workspaces",
  "Inhoud van het bestand": "File contents",
  "Bijvoorbeeld: maak hallo.py dat hallo print en draai het": "For example: make hello.py that prints hello and run it",
  "Opdracht voor de agent": "Task for the agent",
  "Opgeslagen": "Saved",
  "Typ eerst wat de agent moet doen.": "First type what the agent should do.",
  "De agent stopt na de stap waar hij nu mee bezig is.": "The agent stops after the step it is working on now.",
  "Stoppen lukte niet.": "Stopping failed.",
  "Naamloze werkruimte": "Untitled workspace",
  "Repo's": "Repos",
  "Je eigen Git-systeem: elke repo staat op deze Mac, in de map van NovaMund. De hoofdtak heet main.": "Your own Git system: every repo lives on this Mac, in NovaMund's folder. The main branch is called main.",
  "{n} repo's": "{n} repos",
  "Nieuwe repo": "New repo",
  "Naam van de repo": "Repository name",
  "Omschrijving (mag leeg)": "Description (optional)",
  "De repo krijgt meteen een README op main.": "The repo starts with a README on main.",
  "Repo aanmaken": "Create repo",
  "Nog geen repo's. Maak er een met Nieuwe repo.": "No repos yet. Make one with New repo.",
  "{n} takken": "{n} branches",
  "1 repo": "1 repo",
  "1 tak": "1 branch",
  "1 vastlegging": "1 commit",
  "{n} vastleggingen": "{n} commits",
  "Terug naar de repo's": "Back to the repos",
  "Tak": "Branch",
  "Open in Code": "Open in Code",
  "Vastleggingen": "Commits",
  "Terug naar de map": "Back to the folder",
  "Zoek in de code": "Search the code",
  "Zoek": "Search",
  "Geen treffers.": "No matches.",
  "Zoeken vraagt minstens 3 tekens.": "Search needs at least 3 characters.",
  "Wis de zoekvraag": "Clear the search",
  "treffers": "matches",
  "Installatie wacht op jou": "Installation waiting for you",
  "Met npm installeren:": "Install with npm:",
  "Met pip (PyPI) installeren:": "Install with pip (PyPI):",
  "Dit komt mee:": "This comes along:",
  "Installeer": "Install",
  "Ge\u00efnstalleerd. Start de agent opnieuw om het te gebruiken.": "Installed. Start the agent again to use it.",
  // Glasronde 0.9.229 fout 6 en 7.
  "Ge\u00efnstalleerd. De agent gaat verder.": "Installed. The agent carries on.",
  "Dat kon niet worden gewijzigd (fout {code}).": "That could not be changed (error {code}).",
  "Dat kon niet worden gewijzigd: de backend gaf geen antwoord ({reden}). Probeer het opnieuw.":
    "That could not be changed: the backend gave no answer ({reden}). Try again.",
  "Installatie geweigerd.": "Installation refused.",
  "De installatie lukte niet.": "The installation did not work.",
  "Rondes per rit": "Rounds per run",
  "Het aantal rondes kon niet worden opgeslagen.": "The number of rounds could not be saved.",
  "{pad} is gewijzigd door Toepassen; jouw niet-opgeslagen versie staat nog in het bewerkvak.": "{pad} was changed by Apply; your unsaved version is still in the editor.",
  "functie": "function",
  "klasse": "class",
  "Zoeken lukte niet.": "The search did not work.",
  "Dit is een binair bestand; het wordt niet getoond.": "This is a binary file; it is not shown.",
  "Dit bestand is te groot om hier te tonen.": "This file is too large to show here.",
  "Terug naar de vastleggingen": "Back to the commits",
  "De diff is ingekort; de eerste 400 regels staan hier.": "The diff is shortened; the first 400 lines are shown.",
  "verwijderd": "deleted",
  "hernoemd": "renamed",
  "De repo kon niet worden gemaakt.": "The repo could not be created.",
  "Git staat niet op deze Mac, dus repo's kunnen nog niet. Installeer de Command Line Tools van Apple: open Terminal en typ xcode-select --install. Open daarna Repo's opnieuw.": "Git is not on this Mac, so repos cannot be used yet. Install Apple's Command Line Tools: open Terminal and type xcode-select --install. Then open Repos again.",
  "Geef de repo een naam.": "Give the repo a name.",
  "Een repo-naam is hooguit 100 tekens.": "A repo name is at most 100 characters.",
  "Een repo-naam bestaat alleen uit letters, cijfers, streepjes, punten en liggende streepjes, zonder twee punten achter elkaar.": "A repo name has only letters, digits, dashes, dots and underscores, without two dots in a row.",
  "Deze naam is gereserveerd; kies een andere.": "This name is reserved; choose another.",
  "Dia {nr}": "Slide {nr}",
  "{pad} draait met {taal}": "{pad} runs with {taal}",
  "Geen lokaal model dat tekst en gereedschap kan, en geen cloudmodel met een sleutel. Code gebruikt het model van de chat.":
    "No local model that can do text and tools, and no cloud model with a key. Code uses the model of the chat.",
  "Lokale modellen die tekst en gereedschap kunnen, en de cloudmodellen waarvoor een sleutel is ingevuld. De keuze geldt alleen voor Code; de chat houdt haar eigen model.":
    "Local models that can do text and tools, and the cloud models with a key filled in. The choice applies to Code only; the chat keeps its own model.",
  "Netwerk aan voor pakketten (PyPI en npm).": "Network on for packages (PyPI and npm).",
  "Netwerk alleen naar {hosts}.": "Network only to {hosts}.",
  "Netwerk aan voor pakketten (PyPI en npm). Elke installatie vraagt nog jouw toestemming; toetsen draaien zonder netwerk.":
    "Network on for packages (PyPI and npm). Every installation still asks your permission; tests run without network.",
  "Het netwerk van deze werkruimte staat uit.": "The network of this workspace is off.",
  "Netwerk van deze werkruimte": "Network of this workspace",
  "Netwerk voor pakketten": "Network for packages",
  "Alleen toegestane adressen": "Only allowed addresses",
  "Naam van een nieuw bestand, bijvoorbeeld main.py": "Name of a new file, for example main.py",
  "Geen bestand geopend. Kies links een bestand, of typ hierboven een naam voor een nieuw bestand.":
    "No file open. Pick a file on the left, or type a name above for a new file.",
  "{pad} draait met {taal} en heeft {hosts} nodig": "{pad} runs with {taal} and needs {hosts}",
  "{pad} heeft netwerktoegang nodig tot {hosts}": "{pad} needs network access to {hosts}",
  "Geen netwerk": "No network",
  "Code uitvoeren vraagt het Pro-abonnement": "Running code needs the Pro plan",
  "De agent vraagt het Pro-abonnement": "The agent needs the Pro plan",
  "Je routeringsbeleid staat niet toe dat een model dit beantwoordt": "Your routing policy does not allow a model to answer this",
  "De agent kon niet starten": "The agent could not start",
  "Agent werkt…": "Agent working…",
  "Start de agent": "Start the agent",
  "Bezig…": "Working…",
  "Dit bestand uitvoeren": "Run this file",
  "Er kon geen werkruimte worden gemaakt": "No workspace could be made",
  "Deze machine kan code niet veilig uitvoeren; er is niets uitgevoerd": "This machine cannot run code safely; nothing was run",
  "Dat kon niet worden uitgevoerd": "That could not be run",
  "Dat kon niet worden gewijzigd": "That could not be changed",
  "Nieuw team": "New Team",
  "Nog geen teams. Maak er een om samen te werken.": "No teams yet. Create one to collaborate.",
  "Kies een team": "Select a team",
  "Persoonlijk": "Personal",
  "Actief maken": "Make active",
  "Terug naar persoonlijk": "Back to personal",
  "Werkruimte gewisseld": "Workspace switched",
  "Werkruimte wisselen mislukt": "Switching workspace failed",
  "Naar werkruimte": "Move to workspace",
  "Verplaats naar project": "Move to project",
  "Verplaats naar werkruimte": "Move to workspace",
  "De worker staat bij Agenten": "The worker is in Agents",
  "Open bij Agenten": "Open in Agents",
  "Draait {wanneer}, alleen als de Mac aan staat. De uitslag komt in de Postbus.": "Runs {wanneer}, only while the Mac is on. The result goes to the Inbox.",
  "Geen vast tijdstip: je start hem zelf bij Agenten.": "No fixed time: you start it yourself in Agents.",
  "Leest alleen: {bronnen}": "Reads only: {bronnen}",
  "{n} gereedschap van een genoemde koppeling": "{n} tools of a named connection",
  "Leest geen koppelingen; de zin noemde er geen.": "Reads no connections; the sentence named none.",
  "Met een eigen skill voor de werkwijze: {naam}": "With its own skill for the method: {naam}",
  "Aangemaakt.": "Created.",
  "Bevestig en maak de worker": "Confirm and create the worker",
  "Open het gesprek van deze rit": "Open the conversation of this run",
  "Je hebt nu {aantal} koppelingen; de grens van deze organisatie is {grens}.": "You now have {aantal} connections; this organisation's limit is {grens}.",
  "Koppelingen per lid": "Connections per member",
  "Hoeveel eigen koppelingen een lid mag hebben. Standaard {standaard}, waarschuwing vanaf {waarschuwing}, hooguit {plafond}. Leeg is de standaard.": "How many own connections a member may have. Default {standaard}, warning from {waarschuwing}, at most {plafond}. Empty is the default.",
  "Grens bewaard": "Limit saved",
  "Logboek": "Log",
  "Alles wat er is gedaan op een plek: sporen van chats en agents, handelingen op taken en mail, en aanroepen van koppelingen. Alleen lezen.": "Everything that was done in one place: traces of chats and agents, actions on tasks and mail, and calls to connections. Read only.",
  "Het logboek kon niet worden geladen.": "The log could not be loaded.",
  "Alles": "All",
  "Sporen": "Traces",
  "Handelingen": "Actions",
  "Koppelingen": "Connections",
  "Toon logboek": "Show log",
  "Ververs": "Refresh",
  "Nog niets in het logboek.": "Nothing in the log yet.",
  "Spoor": "Trace",
  "Handeling": "Action",
  "Koppeling": "Connection",
  "Intern: deze inhoud gaat niet naar een koppeling buiten de EU": "Internal: this content does not go to a connection outside the EU",
  "Niet meer intern": "No longer internal",
  "Intern kon niet worden omgezet": "Internal could not be switched",
  "Een interne bank gaat nooit naar een koppeling buiten de EU of met een onbekende plek.": "An internal base never goes to a connection outside the EU or with an unknown location.",
  "Intern": "Internal",
  "Niet intern": "Not internal",
  "Adres van de aanbieder": "Address of the provider",
  "Waar staat deze aanbieder?": "Where is this provider?",
  "Alleen https. De sleutel zet je onder Sleutels. Tot je de plek kiest, staat hij als locatie onbekend.": "Only https. You set the key under Keys. Until you choose the location, it shows as location unknown.",
  "De modelnaam zoals de aanbieder hem noemt": "The model name as the provider calls it",
  "Je repositories, issues en pull requests lezen. Alleen lezen: schrijven kan deze koppeling niet. Vul een eigen GitHub-token in.": "Read your repositories, issues and pull requests. Read only: this connection cannot write. Fill in your own GitHub token.",
  "Vul eerst je token in.": "Fill in your token first.",
  "Je token": "Your token",
  "Token voor {naam}": "Token for {naam}",
  "Binnen de EU": "Inside the EU",
  "Eigen netwerk staat aan voor deze koppeling": "Own network is on for this connection",
  "Eigen netwerk staat uit voor deze koppeling": "Own network is off for this connection",
  "Eigen netwerk": "Own network",
  "Eigen computer of eigen netwerk": "Own computer or own network",
  "Alleen voor een adres op je eigen netwerk (bijvoorbeeld 192.168.x of Tailscale). Dan mag ook http, maar alleen naar zo'n adres. Deze machine zelf blijft dicht; een programma op deze Mac koppel je als lokaal programma.": "Only for an address on your own network (for example 192.168.x or Tailscale). Then http is allowed too, but only to such an address. This machine itself stays closed; a program on this Mac you connect as a local program.",
  "Gesprek verplaatst": "Conversation moved",
  "Gesprek verplaatsen mislukt": "Moving the conversation failed",
  "Dit gesprek hoort bij een andere werkruimte": "This conversation belongs to another workspace",
  "Project verplaatst": "Project moved",
  "Project verplaatsen mislukt": "Moving the project failed",
  "Kies een team uit de zijbalk of maak een nieuw.": "Choose a team from the sidebar or create a new one.",
  "Uitnodigen": "Invite",
  "Leden": "Members",
  "Geen leden gevonden": "No members found",
  "Team aanmaken": "Create Team",
  "Teamnaam": "Team Name",
  "Lid uitnodigen": "Invite Member",
  "E-mailadres": "Email Address",
  "Rol": "Role",
  "Lid": "Member",
  "Beheerder": "Admin",
  "Kijker": "Viewer",
  "Mijn team": "My Team",
  "collega@voorbeeld.nl": "colleague@example.com",
  "Team aangemaakt": "Team created",
  "Team aanmaken mislukt": "Failed to create team",
  "Uitgenodigd": "Invited",
  "Lid verwijderd": "Member removed",
  "Lid verwijderen mislukt": "Failed to remove member",
  "Team verwijderd": "Team deleted",
  "Team verwijderen": "Delete team",
  "Team verwijderen? Al het werk van dit team (gesprekken, projecten, kennisbanken, geheugen, agents en skills) gaat terug naar Persoonlijk. Er wordt niets gewist.": "Delete this team? All of its work (conversations, projects, knowledge bases, memory, agents and skills) goes back to Personal. Nothing is erased.",
  "Team verwijderen mislukt": "Failed to delete team",
  "Uitnodigen mislukt": "Failed to invite",
  "Onbekend": "Unknown",
  "Nieuwe chat in dit project": "New chat in this project",
  "Chats in dit project": "Chats in this project",
  "Nog geen chats. Begin er een met de knop hierboven en hij komt hier terecht.": "No chats yet. Start one with the button above and it lands here.",
  "Artefacten": "Artifacts",
  "Nog geen artefacten": "No artifacts yet",
  "Nieuw artefact": "New Artifact",
  "Naam van het artefact": "Artifact name",
  "Inhoud...": "Content...",
  "Project niet gevonden": "Project not found",
  "Project bijgewerkt": "Project updated",
  "Project bijwerken mislukt": "Failed to update project",
  "Project verwijderd": "Project deleted",
  "Project verwijderen mislukt": "Failed to delete project",
  "Een chat beginnen mislukt": "Failed to start a chat",
  "Artefact aangemaakt": "Artifact created",
  "Artefact aanmaken mislukt": "Failed to create artifact",
  "Artefact verwijderd": "Artifact deleted",
  "Artefact verwijderen mislukt": "Failed to delete artifact",
  "Netwerk": "Network",
  "Netwerkkaart": "Network Graph",
  "Automatisch verversen": "Auto-refresh",
  "Jouw node": "Your Node",
  "Opslag": "Storage",
  "Vertrouwen": "Trust",
  "Gevolgde nodes": "Nodes tracked",
  "Betrouwbaar": "Reliable",
  "Gem. betrouwbaarheid": "Avg reliability",
  "Bewijzen": "Receipts",
  "Routeringstabel": "Routing Table",
  "Agentskills": "Agent Skills",
  "Nog geen skills gepubliceerd. Met skills kunnen agenten groeien en nieuwe vermogens delen.": "No skills published yet. Skills allow agents to evolve and share new capabilities.",
  "Vermogens": "Capabilities",
  "Vertraging": "Latency",
  "Geen peers verbonden. Start de backend om naar peers te luisteren.": "No peers connected. Start the backend to listen for peers.",
  "Vertrouwensscore": "Trust score",
  "Opslag vrij": "Storage avail.",
  "Gekoppelde telefoons": "Paired phones",
  "Telefoon koppelen": "Pair a phone",
  "Nog geen telefoons gekoppeld.": "No phones paired yet.",
  "ingetrokken": "revoked",
  "Telefoon gekoppeld": "Phone paired",
  "Adres opgeslagen": "Address saved",
  "Adres gewist": "Address cleared",
  "Een gekoppelde telefoon bereikt deze machine zonder wachtwoord, via een adres dat je al hebt, zoals Tailscale.": "A paired phone reaches this machine without a password, through an address you already have, such as Tailscale.",
  "Scan dit met de camera van je telefoon.": "Scan this with your phone's camera.",
  "Wachten op een telefoon": "Waiting for a phone",
  "Toont je telefoon een ander getal, dan heeft iemand anders de code gescand. Niet bevestigen.": "If your phone shows a different number, someone else scanned the code. Do not confirm.",
  "Ze zijn anders": "They are different",
  "Ja, dat is het getal": "Yes, that is the number",
  "Koppelen kon niet starten": "Pairing could not start",
  "Deze koppeling kon niet worden bevestigd": "This pairing could not be confirmed",
  "Dit apparaat kon niet worden ingetrokken": "This device could not be revoked",
  "Dat adres kon niet worden opgeslagen": "That address could not be saved",
  "Opnieuw proberen": "Try again",
  "SPEAQ ID om een code vragen...": "Asking SPEAQ ID for a code...",
  "Goedgekeurd.": "Approved.",
  "Scan dit met de SPEAQ ID-app op je telefoon.": "Scan this with the SPEAQ ID app on your phone.",
  "Of toon de QR-code": "Or show the QR code",
  "SPEAQ ID openen": "Open SPEAQ ID",
  "Kopieer de code, ga naar je SPEAQ ID-app en plak hem onder Code invoeren.": "Copy the code, then switch to your SPEAQ ID app and paste it under Enter code.",
  "Wachten op goedkeuring in je SPEAQ ID-app": "Waiting for approval in your SPEAQ ID app",
  "De aanmelding is geweigerd in je SPEAQ ID-app.": "The sign-in was refused in your SPEAQ ID app.",
  "Die code geldt niet meer. Begin opnieuw.": "That code is no longer valid. Start again.",
  "Verbind je SPEAQ ID": "Connect your SPEAQ ID",
  "Aanmelden met SPEAQ ID": "Sign in with SPEAQ ID",
  "Of typ deze code in je SPEAQ ID-app.": "Or type this code into your SPEAQ ID app.",
  "Open je SPEAQ ID-app en vul deze code in.": "Open your SPEAQ ID app and enter this code.",
  "Code kopiëren": "Copy code",
  "Stop met wachten": "Stop waiting",
  "Verbreken": "Disconnect",
  "Novamund op je telefoon": "Novamund on your phone",
  "Scan een code en je telefoon draait deze Novamund: deze gesprekken, deze Ollama, deze skills. Op elk netwerk, zonder Tailscale en zonder account ergens. Niets ertussen kan lezen wat er overgaat. De verbinding blijft staan als je dit venster sluit.": "Scan a code and your phone runs this Novamund: these conversations, this Ollama, these skills. On any network, without Tailscale and without an account anywhere. Nothing in between can read what passes. The connection stays when you close this window.",
  "Code tonen": "Show code",
  "Je telefoon slaapt. Deze Mac houdt de verbinding open voor als hij wakker wordt.": "Your phone is asleep. This Mac keeps the connection open for when it wakes up.",
  "Je gekoppelde telefoon kan nog steeds terugkomen terwijl deze code in beeld staat.": "Your paired phone can still come back while this code is on screen.",
  "Scan dit met je telefoon.": "Scan this with your phone.",
  "Wachten op je telefoon": "Waiting for your phone",
  "Je telefoon gebruikt deze Mac.": "Your phone is using this Mac.",
  "Wat je telefoon vroeg": "What your phone asked",
  "Wachten tot hij iets vraagt.": "Waiting until it asks something.",
  "Je telefoon wordt aangemeld...": "Your phone is being signed in...",
  "Deze telefoon kon niet worden aangemeld. Hij toont een aanmeldscherm.": "This phone could not be signed in. It shows a sign-in screen.",
  "Je routeringsbeleid wordt geladen": "Your routing policy is loading",
  "Het routeringsbeleid kon niet worden geladen, dus het kan hier niet worden getoond of gewijzigd. Wat er is opgeslagen, wordt nog steeds toegepast.": "The routing policy could not be loaded, so it cannot be shown or changed here. What is stored is still applied.",
  "Moeilijke vragen mogen deze machine verlaten": "Hard questions may leave this machine",
  "je prompt deze machine verlaat": "your prompt leaves this machine",
  "en bij een bedrijf komt waarvan je een API-sleutel hebt. Je wordt het elke keer eerst gevraagd.": "and reaches a company you have an API key for. You are asked first every time.",
  "Alles blijft op het lokale model.": "Everything stays on the local model.",
  "Aanbieders": "Providers",
  "Modellen": "Models",
  "Er staan geen lokale modellen in de lijst. Ollama moet draaien om ze hier te laten verschijnen.": "There are no local models in the list. Ollama has to be running for them to appear here.",
  "Routeringsbeleid opgeslagen": "Routing policy saved",
  "Het routeringsbeleid kon niet worden opgeslagen": "The routing policy could not be saved",
  "Alleen wat hieronder is aangevinkt mag worden gebruikt. Vink alles in een lijst uit om die beperking helemaal op te heffen.": "Only what is ticked below may be used. Untick everything in a list to lift that limit completely.",
  "Er is niets aangevinkt, dus alles mag. Vink je iets aan, dan mag alleen nog wat in de lijst staat.": "Nothing is ticked, so everything is allowed. Tick something, and only what is in the list is allowed.",
  "Routeringsbeleid opslaan": "Save routing policy",
  "Laden": "Loading",
  "Nog geen documenten. Alles hier wordt vanzelf doorzocht als je in dit project chat.": "No documents yet. Anything here is searched automatically when you chat in this project.",
  "Uit het project halen": "Remove from project",
  "Blijft in de kennisbank": "Stays in the knowledge base",
  "Verwijdert het bestand zelf": "Removes the file itself",
  "Een document toevoegen": "Add a document",
  "Gebruik er een uit een ander project": "Use one from another project",
  "Je eigen kennis": "Your own knowledge",
  "Telt mee in elke chat tenzij je het hier uitzet. Uitzetten verandert niets aan de bestanden, en niets in je andere projecten.": "Counts in every chat unless you switch it off here. Switching it off changes nothing about the files, and nothing in your other projects.",
  "Overal verwijderen": "Delete everywhere",
  "Een document uit een ander project gebruiken": "Use a document from another project",
  "Je andere projecten hebben nog geen documenten.": "Your other projects have no documents yet.",
  "Grenzen ophalen...": "Fetching limits...",
  "Deze grenzen bestaan wel en hebben geen knop": "These limits exist and have no button",
  "Een schakelaar voor iets dat niet bestaat is decoratie. Bij deze vijf zit de grens niet in een slot dat open kan, maar in een vermogen dat er niet is - en dat is de sterkere vorm.": "A switch for something that does not exist is decoration. With these five the limit is not in a lock that can open, but in a capability that is not there - and that is the stronger form.",
  "Twee soorten grens staan hier met opzet niet en blijven": "Two kinds of limit are deliberately not here and stay",
  "vast": "fixed",
  "De grenzen die de": "The limits that guard",
  "integriteit": "integrity",
  "bewaken - het slot op de vault, de vingerafdruk, de rem op te veel krimp - leveren niets op als zij uit staan: er mag dan niets extra's, er wordt alleen stiller vernield.": "- the lock on the vault, the fingerprint, the brake on too much shrinking - gain nothing when they are off: nothing extra is allowed, things are only destroyed more quietly.",
  "En de grenzen die de": "And the limits that guard the",
  "juistheid van een antwoord": "correctness of an answer",
  "bewaken. Uit zetten maakt een antwoord niet vrijer, alleen ongemerkter onjuist.": ". Switching them off does not make an answer freer, only wrong without anyone noticing.",
  "De grenzen konden niet worden opgehaald.": "The limits could not be fetched.",
  "Geen passende opdrachten": "No matching commands",
  "Raad uit": "Council off",
  "Synthese": "Synthesis",
  "Beste van N": "Best of N",
  "Consensus (beoordeeld)": "Consensus (judged)",
  "Scan een code": "Scan a code",
  "De raad heeft minstens twee modellen nodig. Voeg in Instellingen een API-sleutel van een aanbieder toe, of start Ollama.": "The council needs at least two models. Add a provider's API key in Settings, or start Ollama.",
  "LLM-raad UIT": "LLM Council OFF",
  "Nieuwe chat": "New chat",
  "Begin een nieuw gesprek": "Start a fresh conversation",
  "Model wijzigen": "Change model",
  "Haal een model op in Instellingen": "Pull a model in Settings",
  "Stel een aanbieder in onder Instellingen": "Configure a provider in Settings",
  "Aanbieders, API-sleutels, CLAW-domeinen": "Providers, API keys, CLAW domains",
  "Chats zoeken": "Search chats",
  "Een eerder gesprek vinden": "Find a previous conversation",
  "Orkestratie aan of uit": "Toggle orchestrate mode",
  "Staat nu aan": "Currently on",
  "Staat nu uit": "Currently off",
  "LLM-raad": "LLM Council",
  "Niet beschikbaar": "Unavailable",
  "Orkestratie met meerdere agenten AAN": "Multi-agent orchestration ON",
  "Orkestratie met meerdere agenten UIT": "Multi-agent orchestration OFF",
  "Sleutel opslaan": "Save Key",
  "Aan. De assistent kan een pagina lezen die jij noemt of die hij vindt, en elk adres dat hij ophaalt staat bij dat antwoord onder Laat je werk zien.": "On. The assistant can read a page you name or one it finds, and every address it fetches is listed with that answer under Show your work.",
  "Uit. Het gereedschap dat het internet op gaat wordt het model helemaal niet aangeboden, dus het kan het niet per ongeluk gebruiken en ook niet doen alsof: gevraagd naar een website zegt het dat het dat niet kan opzoeken.": "Off. The tool that goes onto the internet is not offered to the model at all, so it cannot use it by accident or pretend to: asked about a website, it says it cannot look that up.",
  "Aan. Vraagt een vraag om een hoeveelheid, dan krijgt het model de hele tabel, en de rij waar het getal uit komt staat onder het antwoord, zodat je het kunt nakijken.": "On. When a question asks for an amount, the model gets the whole table, and the row the number comes from is shown under the answer, so you can check it.",
  "Uit. Antwoorden komen alleen uit de gevonden passages. Een getal in een tabel die de zoekactie niet bereikte wordt niet gevonden, en er staat geen rij bij.": "Off. Answers come only from the passages found. A number in a table the search did not reach is not found, and no row is shown.",
  "Aan. Documenten uit een gekoppelde map krijgen een knop Bewerken. Opslaan overschrijft het .md-bestand op schijf, en dat is hier niet terug te draaien. Alleen markdownbestanden kunnen worden geschreven; een PDF- of Word-bestand wordt geweigerd, omdat er alleen de uitgelezen tekst is geindexeerd en terugschrijven het origineel zou vervangen.": "On. Documents from a linked folder get an Edit button. Saving overwrites the .md file on disk, and that cannot be undone here. Only markdown files can be written; a PDF or Word file is refused, because only the extracted text was indexed and writing back would replace the original.",
  "Uit. Documenten openen alleen om te lezen, en NovaMund raakt geen bestand op schijf aan.": "Off. Documents open for reading only, and NovaMund touches no file on disk.",
  "Winkel en licentie": "Store & License",
  "Licentie activeren": "Activate License",
  "Altijd gratis": "Always Free",
  "Premium-abonnementen": "Premium Plans",
  "/maand": "/month",
  "Alles uit Gratis plus premiumfuncties": "Everything in Free + premium power features",
  "Actief": "Active",
  "Abonneren": "Subscribe",
  "Betaling gelukt. De licentie wordt zo geactiveerd.": "Payment successful! License will be activated shortly.",
  "Betaling geannuleerd.": "Payment cancelled.",
  "Licentiebestand lezen mislukt": "Failed to read license file",
  "Gratis, helemaal offline, geen licentie nodig": "Free tier — fully offline, no license required",
  "Je abonnement opwaarderen": "Upgrade your plan",
  "Kies het abonnement dat bij je past": "Choose the plan that fits your needs",
  "Populair": "Popular",
  "Huidig abonnement": "Current plan",
  "Abonnement beheren": "Manage subscription",
  "Je brengt je eigen AI mee: je eigen sleutel of gratis lokale modellen. We rekenen nooit iets op je tokens. Je betaalt alleen voor het podium, met SPEAQ ID erbij. Studenten vanaf €4,90 per maand. Altijd opzegbaar.": "You bring your own AI - your own key or free local models. We never mark up your tokens. You pay only for the podium, with SPEAQ ID included. Students from €4.90/month. Cancel anytime.",
  "Betalen is nog niet ingesteld. Komt binnenkort.": "Billing not yet configured. Coming soon!",
  "Het betaalportaal openen mislukt": "Failed to open billing portal",
  "Gratis": "Free",
  "Student": "Student",
  "Opwaarderen": "Upgrade",
  "Bestand bewerken": "Edit file",
  "Opnieuw van schijf lezen": "Read from disk again",
  "Uit dit bestand kwam niets leesbaars, dus er is niets te tonen. Het telt nog wel als document, maar het kan geen vraag helpen beantwoorden.": "Nothing readable came out of this file, so there is nothing to show. It still counts as a document, but it cannot help answer a question.",
  "Dit document is langer dan wat hier staat. De rest is geindexeerd en telt nog steeds mee als je er een vraag over stelt.": "This document is longer than what is shown here. The rest is indexed and still counts when you ask a question about it.",
  "Terug": "Back",
  "Bezig met opslaan…": "Saving…",
  "Opslaan in bestand": "Save to file",
  "Dit is het bestand zoals je het zojuist opsloeg, teruggelezen van wat er op schijf is geschreven. Het is niet de geindexeerde tekst; die wordt opnieuw opgebouwd als de map weer wordt ingelezen.": "This is the file as you just saved it, read back from what was written to disk. It is not the indexed text; that is rebuilt when the folder is read in again.",
  "Dit is de tekst die uit het bestand is gehaald toen het werd toegevoegd. Het bestand zelf wordt niet bewaard, dus opmaak, afbeeldingen en indeling horen er niet bij.": "This is the text taken from the file when it was added. The file itself is not kept, so formatting, images and layout are not part of it.",
  "Dit bestand kun je hier niet bewerken. Alleen markdownbestanden (.md) uit een gekoppelde map kunnen worden teruggeschreven; bij al het andere is wat er geindexeerd is de uitgepakte tekst, en die opslaan zou het origineel vervangen.": "You cannot edit this file here. Only markdown files (.md) from a linked folder can be written back; for everything else what was indexed is the extracted text, and saving it would replace the original.",
  "Koppelen met Google kan alleen in de desktop-app. Die koppeling luistert op deze machine, dus vanaf de app op je telefoon kan het niet. Een bron die je met een sleutel koppelt, heeft die beperking niet.": "Connecting to Google only works in the desktop app. That connection listens on this machine, so it cannot be done from the app on your phone. A source you connect with a key does not have that limit.",
  "De koppelingen konden niet worden geladen, dus deze lijst klopt niet met wat je hebt. Er is niets gewijzigd. Open dit tabblad opnieuw om het nog eens te proberen.": "The connections could not be loaded, so this list does not match what you have. Nothing was changed. Open this tab again to try once more.",
  "Deze installatie heeft geen Google-client, dus de Google-bronnen kunnen nog niet worden gekoppeld. Bronnen met een sleutel hebben daar geen last van.": "This installation has no Google client, so the Google sources cannot be connected yet. Sources with a key are not affected.",
  "Er is een browsertabblad geopend. Zeg daar ja, dan komt dit vanzelf terug.": "A browser tab has opened. Say yes there, and this comes back by itself.",
  "Eerdere koppelingen": "Earlier connections",
  "Ontkoppelen trekt de toegang ook bij Google in, niet alleen hier.": "Disconnecting also withdraws the access at Google, not only here.",
  "Ontkoppelen is niet gelukt": "Disconnecting failed",
  "Naar het aanmeldscherm": "To the sign-in screen",
  "Dit account meldt zich aan met je SPEAQ ID.": "This account signs in with your SPEAQ ID.",
  "Ontkoppelen": "Disconnect",
  "Nieuwe telefoon, of de SPEAQ ID-app opnieuw geinstalleerd?": "New phone, or reinstalled the SPEAQ ID app?",
  "Een nieuwe installatie is voor SPEAQ een nieuwe identiteit. Keur hier nog een keer goed, dan volgt dit account hem.": "For SPEAQ a new installation is a new identity. Approve once more here, and this account follows it.",
  "Je wachtwoord blijft hoe dan ook werken, en een telefoon die je al koppelde blijft gekoppeld.": "Your password keeps working either way, and a phone you already paired stays paired.",
  "Koppel je SPEAQ ID om daarmee aan te melden in plaats van een wachtwoord te typen.": "Link your SPEAQ ID to sign in with it instead of typing a password.",
  "Keur goed in je SPEAQ ID-app. Er verandert niets aan je wachtwoord.": "Approve in your SPEAQ ID app. Nothing changes about your password.",
  "SPEAQ ID gekoppeld": "SPEAQ ID linked",
  "SPEAQ ID ontkoppeld": "SPEAQ ID unlinked",
  "Bewerken staat uit. Zet “Wijzigingen terugschrijven naar het bestand” aan onder Instellingen › Meer om dit document te bewerken.": "Editing is off. Turn on “Write changes back to the file” under Settings › More to edit this document.",
  "Soort:": "Type:",
  "Tekst": "Text",
  "Artefact niet gevonden": "Artifact not found",
  "Artefact opgeslagen": "Artifact saved",
  "Artefact opslaan mislukt": "Failed to save artifact",
  "Noodstop staat aan": "Emergency stop is on",
  "NovaMund voert niets uit. Opheffen doe je zelf, buiten de app om: verwijder het bestand dat hieronder staat.": "NovaMund runs nothing. You lift it yourself, outside the app: delete the file shown below.",
  "Noodstop": "Emergency stop",
  "Dit stopt alles wat NovaMund uitvoert. Je kunt het daarna alleen zelf weer aanzetten, buiten de app om.": "This stops everything NovaMund runs. Afterwards only you can switch it back on, outside the app.",
  "Stop alles": "Stop everything",
  "Laat maar": "Never mind",
  "Waarom stop je?": "Why are you stopping?",
  "De noodstop staat aan. Er gebeurt niets meer.": "The emergency stop is on. Nothing happens any more.",
  "De noodstop kon niet worden gezet.": "The emergency stop could not be set.",
  "Een sleutel maken op deze telefoon...": "Making a key on this phone...",
  "Kijk of je computer hetzelfde getal toont en bevestig het daar.": "Check that your computer shows this same number, then confirm it there.",
  "Wachten tot je op de computer bevestigt": "Waiting for you to confirm on the computer",
  "Zijn de getallen anders, bevestig dan niet. Iemand anders probeert te koppelen.": "If the numbers are different, do not confirm. Someone else is trying to pair.",
  "Gekoppeld. Novamund wordt geopend.": "Paired. Opening Novamund.",
  "Terug naar Novamund": "Back to Novamund",
  "Telefoon": "Phone",
  "Deze koppeling staat niet meer open.": "This pairing is no longer open.",
  "Spring naar een datum of maand": "Jump to a date or month",
  "Bezig...": "Working...",
  "Er is nog niets om terug te kijken.": "There is nothing to look back on yet.",
  "Op deze dag is niets gezegd.": "Nothing was said on this day.",
  "Terug naar de dagen": "Back to the days",
  "2026-07, juli 2026 of 15 juli 2026": "2026-07, July 2026 or 15 July 2026",
  "Er is nog geen enkele dag om heen te springen.": "There is not a single day to jump to yet.",
  "De AI wil de volgende handeling uitvoeren:": "The AI wants to perform the following action:",
  "Tekst:": "Text:",
  "Velden:": "Fields:",
  "Blokkeren": "Block",
  "Toestaan": "Allow",
  "Element aanklikken": "Click Element",
  "Tekst typen": "Type Text",
  "Formulier invullen": "Fill Form",
  "Abonnement": "Billing",
  "· verlopen": "· expired",
  "Nog geen betaalaccount; neem eerst een betaald abonnement": "No billing account yet — subscribe to a paid plan first",
  "Geen kosten": "No cost",
  "Abonnementen bekijken": "View plans",
  "Abonnement opwaarderen": "Upgrade plan",
  "Afkortingen": "Abbreviations",
  "Staat de afkorting in je vraag, dan zoekt NovaMund ook op de voluit-vorm. Bijvoorbeeld EP voor Export Partners.": "If the abbreviation is in your question, NovaMund also searches for the full form. For example EP for Export Partners.",
  "afkorting": "abbreviation",
  "Afkorting": "Abbreviation",
  "voluit": "full form",
  "Voluit": "Full form",
  "Voeg afkorting toe": "Add abbreviation",
  "Gesprekken zoeken": "Search Conversations",
  "Zoeken...": "Searching...",
  "Typ minstens 2 tekens om te zoeken": "Type at least 2 characters to search",
  "Tip: gebruik": "Tip: Use",
  "om zoeken altijd te openen": "to open search anytime",
  "Berichten en gesprekken zoeken... (⌘K)": "Search messages and conversations... (⌘K)",
  "Novamund heeft de camera nodig om de code te lezen. Sta het toe als je browser erom vraagt.": "Novamund needs the camera to read the code. Allow it when your browser asks.",
  "Scanner sluiten": "Close scanner",
  "Dit bericht zou je machine verlaten": "This message would leave your machine",
  "Je lokale model geeft diep werk door aan een externe aanbieder. Dit bericht valt daaronder, dus de hele tekst zou worden verstuurd naar:": "Your local model is set up to hand deep work to an external provider. This message qualifies, so its full text would be sent to:",
  "Niet meer vragen in dit gesprek": "Do not ask again for this conversation",
  "Lokaal houden": "Keep it local",
  "De app en de backend hebben verschillende versies. Op een telefoon betekent dit dat de gekoppelde machine nog niet is bijgewerkt.": "The app and the backend are on different versions. On a phone this means the machine it is paired with has not been updated yet.",
  "Automatisch bijwerken heeft nog niet naar deze kennisbank gekeken.": "Automatic updating has not looked at this knowledge base yet.",
  "Bronmap niet bereikbaar": "Source folder not reachable",
  "Bronmap kwam leeg terug": "Source folder came back empty",
  "Bijwerken mislukte binnen de app": "Updating failed inside the app",
  "Projectopties voor dit gesprek": "Project options for this conversation",
  "Geen project": "No project",
  "Naar project": "Move to project",
  "Uit project halen": "Remove from project",
  "Verbindingslog": "Connection log",
  "Wissen": "Clear",
  "Wanneer het kanaal openging en sloot, wanneer dit apparaat sliep en wakker werd, en elke poging om de verbinding weer op te pakken. Nieuwste bovenaan.": "When the channel opened and closed, when this device slept and woke, and every attempt to pick the connection up again. Newest at the top.",
  "Nog niets vastgelegd.": "Nothing recorded yet.",
  "Je computer zoeken...": "Looking for your computer...",
  "Verbonden met je Mac. Je wordt aangemeld.": "Connected to your Mac. Signing you in.",
  "Aangemeld op je Mac. Novamund wordt geopend.": "Signed in on your Mac. Opening Novamund.",
  "Verbonden met je Mac. Deze telefoon is niet aangemeld.": "Connected to your Mac. It did not sign this phone in.",
  "Het spoor van deze agent kon niet worden geladen. Er wordt niets over zijn werk beweerd.": "Could not load this agent's trail. Nothing is claimed about its work either way.",
  "Wat hij heeft gedaan": "What it has done",
  "Nog niets. Runs verschijnen hier zodra deze agent iets heeft gedaan.": "Nothing yet. Runs appear here as soon as this agent has done something.",
  "Nagekeken: ongewijzigd sinds het is geschreven": "Verified: unchanged since it was written",
  "Een wijziging valt op, maar is niet onmogelijk: er zijn geen sleutels, dus dit laat zien dat een regel is gewijzigd, niet dat hij niet gewijzigd kan worden.": "Tamper-evident, not tamper-resistant: there are no keys, so this shows that a row was changed, not that it cannot be.",
  "Gewijzigd: dit klopt niet meer met wat is vastgelegd": "Altered: this no longer matches what was recorded",
  "Geschreven voordat de recorder een keten bijhield, dus er valt niets na te kijken": "Written before the recorder kept a chain, so there is nothing to check",
  "Hoe de voorstellen gingen": "How proposals went",
  "Nog niets besloten. Dit begint te tellen zodra je iets aanneemt of weigert.": "Nothing decided yet. This starts counting once you accept or refuse something.",
  "geweigerd": "refused",
  "naslag": "reference",
  "Vorm en uitgewerkte voorbeelden. Niet doorzocht in chats; gebruikt als een agent deze bank noemt.": "Format and worked examples. Not searched in chats; used when an agent names this base.",
  "in het midden ingekort": "shortened in the middle",
  "Toestaan…": "Allow…",
  "Telt mee in dit gesprek": "Counts in this conversation",
  "dit project": "this project",
  "Alles uit": "All off",
  "Draait op je Mac, via je eigen verbinding.": "Running on your Mac, through your own connection.",
  "De verbinding met je Mac wordt hersteld.": "The connection with your Mac is being restored.",
  "Open opnieuw": "Open again",
  "Melding wegklikken": "Dismiss notice",
  "Verbinding met je Mac zoeken…": "Looking for your Mac…",
  "Wat NovaMund al kan": "What NovaMund can already do",
  "geen antwoord": "no answer",
  "De afkortingen konden niet worden opgehaald.": "The abbreviations could not be fetched.",
  "De afkorting is niet opgeslagen.": "The abbreviation was not saved.",
  "De afkorting is niet weggehaald.": "The abbreviation was not removed.",
  "Omzetten is niet gelukt.": "Switching failed.",
  "Koppelen is niet gelukt": "Connecting failed",
  "De sleutel opslaan is niet gelukt": "Saving the key failed",
  "Die SPEAQ ID kon niet worden gekoppeld": "That SPEAQ ID could not be linked",
  "De verbinding met je Mac is weg.": "The connection with your Mac is gone.",
  "Kies een model": "Select model",
  "Afrekenen gestart": "Checkout started",
  "Opwaarderen starten mislukt": "Failed to start upgrade",
  "Er kon geen directe verbinding worden geopend.": "Could not open a direct connection.",
  "Koppelen kon niet starten.": "Pairing could not be started.",
  "Model {m} is gedownload": "Model {m} has been downloaded",
  "{f} is te groot (hooguit 10 MB)": "{f} is too large (max 10 MB)",
  "{f}: het bestand is leeg of nog niet gedownload. Download het eerst en voeg het dan opnieuw toe.": "{f}: the file is empty or not downloaded yet. Download it first, then attach it again.",
  "{f}: dit soort bestand wordt niet ondersteund": "{f}: unsupported file type",
  "{d} kan deze machine niet meer bereiken": "{d} can no longer reach this machine",
  "{n} document(en) aan dit project toegevoegd": "{n} document(s) added to this project",
  "{f} telt nu mee in dit project": "{f} now counts in this project",
  "{f} verwijderd": "{f} deleted",
  "Vergeten: {tekst}": "Forgotten: {tekst}",
  "Netwerk van deze werkruimte: {w}": "Network of this workspace: {w}",
  "{f} geïmporteerd": "Imported {f}",
  "Apparaat": "Device",
  "{bron} gekoppeld": "{bron} connected",
  "Scan de code opnieuw om verder te gaan.": "Scan the code again to continue.",
  // R1 punt 9 (15 okt): de vaste woorden van het bronblok, bij het tekenen
  // vertaald door `lib/bronwoorden.js`, en de wachtbalk en de denktijd.
  "bron": "source",
  "venster": "window",
  "selectie": "selection",
  "werkruimtes": "workspaces",
  "niet geraadpleegd": "not consulted",
  "gelezen als": "read as",
  "wat opvalt": "notable",
  "hele dag": "all day",
  "geen bron": "no source",
  "gesprek": "conversation",
  "systeemklok": "system clock",
  "vorig antwoord": "previous answer",
  "de klok van deze machine": "the clock of this machine",
  "je eigen vraag": "your own question",
  "de bronnen onder dit antwoord": "the sources under this answer",
  "{n} gevonden": "{n} found",
  "1 voorstel wacht in Geheugen": "1 suggestion is waiting in Memory",
  "{n} voorstellen wachten in Geheugen": "{n} suggestions are waiting in Memory",
  "Nagedacht {n} s": "Thought for {n} s",
  // R1 punt 9: de vaardigheidskaarten (`lib/abilities.js`), vertaald bij het tekenen.
  "Elk antwoord wordt tegen je eigen bronnen gehouden: beweringen, getallen en tijden die niet in het materiaal staan, worden tegengehouden of gemeld.": "Every answer is checked against your own sources: claims, numbers and times that are not in the material are stopped or flagged.",
  "Onder elk antwoord, in het bronblok.": "Under every answer, in the source block.",
  "Naar de chat": "Go to the chat",
  "Tabellen uit je documenten worden heel bewaard; een vraag naar een rij of een getal haalt de cel op, en een telling of som rekent NovaMund zelf uit.": "Tables from your documents are kept whole; a question about a row or a number fetches the cell, and NovaMund works out a count or a sum itself.",
  "Vraag in de chat naar een rij uit een tabel in je kennisbank.": "Ask in the chat for a row from a table in your knowledge base.",
  "Naar je kennisbanken": "Go to your knowledge bases",
  "De raad: meerdere modellen lezen dezelfde tekst of vraag en leggen hun bezwaren naast elkaar.": "The council: several models read the same text or question and put their objections side by side.",
  "In de chat, met de knop voor de raad naast het invoerveld.": "In the chat, with the council button next to the input field.",
  "De oogst leest je gesprekken terug en zet wat het onthouden waard lijkt als voorstel klaar. Jij beslist wat blijft.": "The harvest reads back your conversations and prepares what seems worth remembering as a suggestion. You decide what stays.",
  "Op de pagina Geheugen, bij de voorstellen.": "On the Memory page, under the suggestions.",
  "Naar Geheugen": "Go to Memory",
  // R1 punt 9: losse Nederlandse tekst in de schermen, gevonden met een scan op JSX-tekst.
  "Dit is het bestand op schijf, niet de uitgepakte tekst hierboven. Opslaan overschrijft {f}, en dat kun je hier niet ongedaan maken.": "This is the file on disk, not the extracted text above. Saving overwrites {f}, and you cannot undo that here.",
  "Opgeslagen in {f}.": "Saved in {f}.",
  "Zoeken gebruikt nog de oudere geindexeerde versie tot de map opnieuw is ingelezen.": "Search still uses the older indexed version until the folder has been read in again.",
  "Zoeken kent de nieuwe tekst al: het document is meteen opnieuw ingelezen.": "Search already knows the new text: the document was read in again straight away.",
  "Zoeken kende deze tekst al; er was niets opnieuw in te lezen.": "Search already knew this text; there was nothing to read in again.",
  "Deze kennisbank wordt nu ingelezen. Zoeken neemt de nieuwe tekst mee in de volgende ronde, binnen een kwartier.": "This knowledge base is being read in right now. Search will pick up the new text in the next round, within fifteen minutes.",
  "Inlezen staat uit voor deze kennisbank, dus zoeken gebruikt nog de oudere versie.": "Reading in is switched off for this knowledge base, so search still uses the older version.",
  "Opnieuw inlezen lukte niet ({reden}). Het bestand is wel opgeslagen; de volgende ronde probeert het opnieuw, binnen een kwartier.": "Reading it in again did not work ({reden}). The file has been saved; the next round will try again, within fifteen minutes.",
  "Dit is het bestand zoals je het zojuist opsloeg, teruggelezen van wat er op schijf is geschreven. De geindexeerde tekst is er meteen opnieuw uit opgebouwd.": "This is the file as you just saved it, read back from what was written to disk. The indexed text was rebuilt from it straight away.",
  "Niets op te slaan: {f} is ongewijzigd. Het bestand is niet aangeraakt, dus de tijdstempel is niet verschoven en Dropbox heeft niets bij te werken.": "Nothing to save: {f} is unchanged. The file was not touched, so its timestamp did not move and Dropbox has nothing to update.",
  "(laatst gekeken: {w}).": "(last checked: {w}).",
  "Er is niets uit deze kennisbank verwijderd.": "Nothing has been removed from this knowledge base.",
  "Er is niets verwijderd, want een losgekoppelde schijf ziet er precies zo uit als een leeggemaakte map.": "Nothing has been removed, because a disconnected drive looks exactly like an emptied folder.",
  "Automatisch bijwerken staat uit voor deze kennisbank. Laatst gekeken: {w}.": "Automatic updating is off for this knowledge base. Last checked: {w}.",
  "Er gebeurt niets tot je kiest.": "Nothing happens until you choose.",
  "Koppel {naam}": "Connect {naam}",
  "De sleutel wordt eerst bij {naam} gecontroleerd, dus een verkeerde sleutel wordt hier geweigerd en niet uren later. Hij staat versleuteld op deze machine en gaat nooit naar het model.": "The key is first checked with {naam}, so a wrong key is refused here and not hours later. It is stored encrypted on this machine and never goes to the model.",
  "Staat er een grens open, dan zie je dat bovenin het chatscherm aan het teken \"Open: ...\". Zo is het ook te zien voor wie dit scherm niet opent.": "If a limit is open, you see it at the top of the chat screen by the sign \"Open: ...\". That way it is visible even to someone who never opens this screen.",
  "uit de tabel": "from the table",
  "Adres waarop een telefoon deze machine bereikt": "Address at which a phone reaches this machine",
  "(waar het kan automatisch bepaald)": "(worked out automatically when it can be)",
  "De ronde gaf het op na vijf pogingen: {fout}": "The round gave up after five attempts: {fout}",
  "Achterstand": "Overdue",
  "Vandaag": "Today",
  "Voorstel uit de {herkomst}. Er gebeurt niets tot je bevestigt.": "Suggestion from the {herkomst}. Nothing happens until you confirm.",
  "postbus": "inbox",
  "Standaard uit, en uit is uit. Staat dit aan, dan gaat een vraag waar het lokale model naar verwachting slecht in is naar een cloudaanbieder, en dat betekent dat": "Off by default, and off means off. When this is on, a question the local model is expected to handle badly goes to a cloud provider, and that means",
  "Een raad heeft {n} leden. Alleen de eerste {n} hiervan doen mee, en een aanbieder waarvoor je een API-sleutel hebt, telt eerst.": "A council has {n} members. Only the first {n} of these take part, and a provider you have an API key for counts first.",
  "{n} konden niet worden gelezen:": "{n} could not be read:",
  "{fout} van {n} bestanden konden niet worden gelezen, dus hun inhoud is niet doorzoekbaar.": "{fout} of {n} files could not be read, so their content is not searchable.",
  "Het geheugen heeft geen maximum. Er verdwijnt nooit een regel om ruimte te maken; bij elke vraag gaan alleen de regels mee die erbij horen.": "Memory has no maximum. A line is never dropped to make room; each question takes along only the lines that belong to it.",
  "Je node draait volledig op je eigen machine. De licentie wordt hier gecontroleerd, zonder contact met een server. Stripe verwerkt alleen betalingen; er gaan geen gebruiksgegevens van je machine af.": "Your node is fully self-hosted. License verification is performed locally, with no phone-home. Stripe handles payments only; no usage data leaves your machine.",
  // R2: Settings > Limits, statussen en geschiedenis.
  "staat open": "is open",
  "staat dicht": "is closed",
  "sinds {wanneer}": "since {wanneer}",
  "overgenomen uit Instellingen": "taken over from Settings",
  "overgenomen uit Instellingen (fix 12, eenmalig)": "taken over from Settings (fix 12, once)",
  "versie {n}": "version {n}",
  "dicht": "closed",
  "open": "open",
  "{n} open": "{n} open",
  "voor {gebied}": "for {gebied}",
  "op {wanneer}": "on {wanneer}",
  "dichtzetten": "close",
  "openzetten": "open",
  // C1 punt 3: uitleg en voorbeelden op het Code-scherm.
  "Hier laat je NovaMund code schrijven en uitvoeren in een afgesloten map op deze machine. Typ onderaan een opdracht in gewone taal, of kies een voorbeeld; je ziet de opdracht eerst in het vak en start hem zelf.": "Here NovaMund writes and runs code in a closed-off folder on this machine. Type a task in plain language below, or pick an example; you see the task in the box first and start it yourself.",
  "CSV's samenvoegen": "Merge CSV files",
  "Marges doorrekenen": "Work out margins",
  "Bestanden hernoemen": "Rename files",
  "Voeg alle CSV-bestanden in deze map samen tot een bestand samen.csv, met de kopregel een keer bovenaan, en meld hoeveel rijen er uit elk bestand kwamen.": "Merge all CSV files in this folder into one file merged.csv, with the header row once at the top, and report how many rows came from each file.",
  "Reken in prijzen.csv per regel de marge uit als (verkoopprijs - inkoopprijs) / verkoopprijs, zet die als nieuwe kolom erbij en geef de gemiddelde marge.": "In prices.csv, work out the margin per row as (selling price - purchase price) / selling price, add it as a new column and give the average margin.",
  "Hernoem alle bestanden in deze map naar kleine letters met streepjes in plaats van spaties, en toon eerst de lijst oud naar nieuw voordat je iets hernoemt.": "Rename all files in this folder to lower case with dashes instead of spaces, and show the list old to new first before renaming anything.",
  // C3: het label van het bronblok.
  "Bronnen onder dit antwoord": "Sources under this answer",
  // C2a: een koppeling die een toestemming mist.
  "Gekoppeld": "Connected",
  "Deze koppeling mist een toestemming die NovaMund nu vraagt. Koppel opnieuw; Google vraagt je dan om die extra toestemming.": "This connection lacks a permission NovaMund now asks for. Connect again; Google will then ask you for that extra permission.",
  "Opnieuw koppelen": "Connect again",
  "Mag lezen: {bronnen}. Alleen lezen; schrijven doet hij niet.": "May read: {bronnen}. Read only; it does not write.",
  "leest {bronnen}": "reads {bronnen}",
  "Planning: {wanneer}.": "Schedule: {wanneer}.",
  "Volgende keer: {moment}, alleen als de Mac aan staat.": "Next time: {moment}, only while the Mac is on.",
  "{bron} opnieuw koppelen": "Connect {bron} again",
  "De toegang tot {bron} is verlopen of ingetrokken bij Google. Koppel opnieuw om weer te kunnen lezen.": "Access to {bron} expired or was revoked at Google. Connect again to read it once more.",
  "{bron} is hier ontkoppeld": "{bron} is disconnected here",
  "{bron} is ontkoppeld; bij Google was de toegang al vervallen": "{bron} is disconnected; at Google the access had already lapsed",
  "{bron} is hier ontkoppeld. Bij Google blijft de toestemming staan, omdat je andere Google-koppelingen die delen.": "{bron} is disconnected here. At Google the permission stays, because your other Google connections share it.",
  "{bron} is ontkoppeld, ook bij Google": "{bron} is disconnected, at Google too",
  "Je agenda, gelezen op deze machine voor je dag. Een afspraak zet NovaMund er alleen in nadat jij hem op een kaart hebt bevestigd.": "Your calendar, read on this machine for your day. NovaMund only adds an event after you have confirmed it on a card.",
  "Welke documenten je vandaag wijzigde, met naam en tijd. Alleen lezen, en de inhoud van je bestanden gaat niet naar het model.": "Which documents you changed today, with name and time. Read only, and the contents of your files do not go to the model.",
  "Je mail van de dag, en een antwoord op een bericht als je daarom vraagt. Elk antwoord zie je eerst helemaal, en het gaat pas weg na jouw bevestiging.": "Your mail of the day, and a reply to a message when you ask for one. You see every reply in full first, and it only leaves after your confirmation.",
  "Je Fathom-opnamen en hun transcripten, gelezen met een sleutel die je hier plakt. De sleutel staat versleuteld op deze machine en nergens anders.": "Your Fathom recordings and their transcripts, read with a key you paste here. The key is stored encrypted on this machine and nowhere else.",
  "Je TASQ-taken, zodat ze bij je dag horen: wat er moet en waar je aan werkt, in elke werkruimte die je token dekt. Aanmaken en wijzigen gaat altijd via een kaart die je eerst bevestigt. Het token staat versleuteld op deze machine en nergens anders.": "Your TASQ tasks, so they are part of your day: what needs doing and what you are working on, in every workspace your token covers. Creating and changing always goes through a card you confirm first. The token is stored encrypted on this machine and nowhere else.",
  "Er hangt al een koppeling met deze bron. Ontkoppel die eerst, dan weet je zeker welke er staat.": "There is already a connection with this source. Disconnect it first, so you know for sure which one is in place.",
  // C2a: de afspraakkaart.
  "Dit voorstel kon niet worden geladen": "This suggestion could not be loaded",
  "Afspraak staat in je agenda": "The appointment is in your calendar",
  "Staat in je agenda.": "It is in your calendar.",
  "Open in Google Calendar": "Open in Google Calendar",
  "Bevestig en zet in mijn agenda": "Confirm and add to my calendar",
  // F1e: Instellingen > Organisatie.
  "Organisatie": "Organisation",
  "Eigenaar": "Owner",
  // "Lid", "Kijker" en "Leden" staan al hierboven (Teams-scherm), met dezelfde vertaling.
  "jij": "you",
  "Zonder naam": "No name",
  "Bewaar": "Save",
  "Naam bewaard": "Name saved",
  "Naam van de organisatie": "Name of the organisation",
  "Rol van {naam}": "Role of {naam}",
  "De organisatie kon niet worden geladen.": "The organisation could not be loaded.",
  "Dat lukte niet. Er is niets gewijzigd.": "That did not work. Nothing was changed.",
  "Deze installatie is een organisatie. Iedereen die hier inlogt, is lid met een rol.": "This installation is an organisation. Everyone who signs in here is a member with a role.",
  "Een eigenaar beheert de organisatie. Een lid werkt mee en bevestigt kaarten. Een kijker ziet alles maar bevestigt niets en start geen agent.": "An owner manages the organisation. A member takes part and confirms cards. A viewer sees everything but confirms nothing and starts no agent.",
  "Delen met organisatie": "Share with organisation",
  "Iedereen in de organisatie kan deze agent dan zien en starten. Kennisbanken en skills komen van wie hem start.": "Everyone in the organisation can then see and start this agent. Knowledge bases and skills come from whoever starts it.",
  "Gedeeld met de organisatie": "Shared with the organisation",
  "Weer alleen voor jou": "Back to only you",
  "Gedeeld door een ander lid": "Shared by another member",
  "Terugzetten": "Undo sharing",
  // F2a, Nextcloud (17 oktober 2026)
  "Je eigen Nextcloud-server, met een app-wachtwoord. Bestanden, agenda, contacten en meldingen volgen per onderdeel.": "Your own Nextcloud server, with an app password. Files, calendar, contacts and notifications follow one by one.",
  "Koppelen is niet gelukt. Er is niets opgeslagen.": "Connecting did not work. Nothing was saved.",
  "Nextcloud is hier ontkoppeld": "Nextcloud is disconnected here",
  "Ontkoppelen vergeet het app-wachtwoord hier. Het blijft geldig in Nextcloud tot je het daar intrekt.": "Disconnecting forgets the app password here. It stays valid in Nextcloud until you revoke it there.",
  "Serveradres": "Server address",
  "Gebruikersnaam": "Username",
  "App-wachtwoord": "App password",
  "Maak het app-wachtwoord in Nextcloud bij Instellingen > Beveiliging. Alleen https.": "Create the app password in Nextcloud under Settings > Security. https only.",
  "Koppelen": "Connect",
  "Nog niet beschikbaar": "Not available yet",
  "Bronkeuze bewaard": "Source choice saved",
  "Agenda en bestanden uit": "Calendar and files from",
  "Geldt voor de agenda in je ochtendronde en voor vragen over je bestanden. De Nextcloud-agenda komt met een volgende versie.": "Applies to the calendar in your morning round and to questions about your files. The Nextcloud calendar comes with a later version.",
  "Je bent kijker in deze organisatie. Alleen een eigenaar of lid kan Nextcloud koppelen.": "You are a viewer in this organisation. Only an owner or member can connect Nextcloud.",
  // I4, MCP-bevestigingskaart (17 oktober 2026)
  "Er is niets verstuurd": "Nothing was sent",
  "Uitgevoerd": "Done",
  "Mislukt": "Failed",
  "Geweigerd": "Declined",
  "Bezig": "In progress",
  "wil een MCP-gereedschap aanroepen": "wants to call an MCP tool",
  "Server": "Server",
  "Zonder argumenten": "No arguments",
  "Bevestig en verstuur": "Confirm and send",
  "Alleen een eigenaar of lid kan dit bevestigen.": "Only an owner or member can confirm this.",
  "Een MCP-aanroep wacht op je bevestiging": "One MCP call is waiting for your confirmation",
  "MCP-aanroepen wachten op je bevestiging": "MCP calls are waiting for your confirmation",
  "Het resultaat staat in het gesprek": "The result is in the conversation",
  // I6, Instellingen > Verbindingen > MCP-servers en de agentkaart (17 oktober 2026)
  "Nog niet getoetst": "Not tested yet",
  "1 gereedschap": "1 tool",
  "gereedschappen": "tools",
  "MCP-server gekoppeld": "MCP server connected",
  "MCP-server getoetst": "MCP server tested",
  "MCP-server ontkoppeld": "MCP server disconnected",
  "MCP-servers": "MCP servers",
  "met sleutel": "with key",
  "Aan": "On",
  "Toetsen": "Test",
  "Je bent kijker in deze organisatie. Alleen een eigenaar of lid kan MCP-servers koppelen.": "You are a viewer in this organisation. Only an owner or member can connect MCP servers.",
  "Sleutel (optioneel)": "Key (optional)",
  "Alleen https. Een sleutel hoort in het sleutelveld, niet in het adres.": "https only. A key belongs in the key field, not in the address.",
  "op": "on",
  // I7, plusmenu bij het chatveld (17 oktober 2026)
  "Connectors in dit gesprek": "Connectors in this conversation",
  "Nog geen connectors gekoppeld.": "No connectors connected yet.",
  "Connectors beheren": "Manage connectors",
  "komt later": "coming later",
  "uit in Instellingen": "off in Settings",
  "aan": "on",
  "uit in dit gesprek": "off in this conversation",
  // Glasronde 17 oktober 2026: bijlage als kaartje in het gesprek
  "Bijlage": "Attachment",
  "Afbeelding": "Image",
  "Bestand": "File",
  "Openen": "Open",
  "inhoud niet bewaard": "content not kept",
  // J7 (18 oktober 2026): openen via Downloads en bekijken in de app
  "Bekijken": "View",
  "Bezig met lezen": "Reading",
  "Bekijken lukte niet.": "Viewing did not work.",
  "Geopend vanuit Downloads": "Opened from Downloads",
  "Bewaard in Downloads": "Saved in Downloads",
  "Openen lukte niet": "Opening did not work",
  // I3, lokaal MCP-programma (17 oktober 2026)
  "Starten is niet gelukt.": "Starting did not work.",
  "Dit commando start op deze machine:": "This command starts on this machine:",
  "Bevestig en start": "Confirm and start",
  "Lokaal programma gekoppeld. Het draait pas na Starten.": "Local program connected. It only runs after Start.",
  "Lokaal programma gestopt": "Local program stopped",
  "Draait": "Running",
  "Gestopt": "Stopped",
  "Starten": "Start",
  "Stoppen": "Stop",
  "Lokaal programma gestart": "Local program started",
  "Lokaal programma": "Local program",
  "Programma": "Program",
  "Kies een programma": "Choose a program",
  "Mappen, een per regel": "Folders, one per line",
  "Alleen programma's van deze lijst. NovaMund installeert niets; het pakket moet er al staan.": "Only programs from this list. NovaMund installs nothing; the package must already be there.",
  // H3, eerste-startscherm (18 okt 2026)
  "Kies je basismap": "Choose your base folder",
  "De basismap is de map waarin je vault staat, bijvoorbeeld Plexaris Brain. Kennisbanken onthouden hun map ten opzichte van deze map, zodat ze ook werken als de vault op een andere plek staat.": "The base folder is the folder that holds your vault, for example Plexaris Brain. Knowledge bases remember their folder relative to it, so they keep working when the vault lives somewhere else.",
  "Kies map...": "Choose folder...",
  "Later": "Later",
  "Alleen een eigenaar kan de basismap kiezen.": "Only an owner can choose the base folder.",
  "Dit is geen bestaande map met een volledig pad.": "This is not an existing folder with a full path.",
  // F3a, installatieprofiel (20 okt 2026)
  "De map uit het profiel bestaat niet op deze Mac: {pad}. Kies een map.": "The folder from the profile does not exist on this Mac: {pad}. Choose a folder.",
  "Taal": "Language",
  "Nextcloud-adres (data-thuis)": "Nextcloud address (data home)",
  "Data-thuis": "Data home",
  "Het Nextcloud-adres waar de data van deze organisatie thuis is. Het vult het koppelformulier voor; inloggen doet ieder lid zelf.": "The Nextcloud address where this organisation's data lives. It fills in the link form; each member signs in themselves.",
  "Adres bewaard": "Address saved",
  // F3b, huisstijl per organisatie (20 okt 2026)
  "De huisstijl geldt voor de hele organisatie. Het NovaMund-beeldmerk blijft altijd staan; je eigen logo komt ernaast. Lege velden vallen terug op de standaard van NovaMund.": "The house style applies to the whole organisation. The NovaMund mark always stays; your own logo goes next to it. Empty fields fall back to the NovaMund default.",
  "Alleen een eigenaar kan de huisstijl wijzigen.": "Only an owner can change the house style.",
  "een product van NovaMund": "a NovaMund product",
  "NovaMund. Een eigen huisstijl verandert de naam en de kleur, niet het product.": "NovaMund. A house style of your own changes the name and the colour, not the product.",
  "Huisstijl uit het profiel": "House style from the profile",
  "Logo, naast het NovaMund-beeldmerk": "Logo, next to the NovaMund mark",
  "Later te wijzigen in Instellingen > Merk.": "You can change this later in Settings > Brand.",
  // Blok Basismap in Instellingen > Meer (18 okt 2026)
  "Basismap": "Base folder",
  "De map waarin je vault staat. Kennisbanken lezen hun map ten opzichte van deze map; kies je een andere, dan zoeken ze hun mappen daar.": "The folder that holds your vault. Knowledge bases read their folder relative to it; choose another one and they look for their folders there.",
  "Nog geen basismap gekozen.": "No base folder chosen yet.",
  "Wijzigen kan alleen in de app op de Mac.": "You can only change this in the app on the Mac.",
  // J1, een antwoord als document (18 okt 2026)
  "Maak document": "Make document",
  "Het document is groter dan 5 MB.": "The document is larger than 5 MB.",
  "Van dit antwoord kan geen document worden gemaakt.": "No document can be made from this answer.",
  "Het document maken is niet gelukt.": "Making the document did not work.",
  // CC4-a, een herschrijving met naleesstap (GL216-5, 29 okt 2026)
  "Over dit voorstel is al besloten.": "This proposal has already been decided.",
  "Het originele document staat niet meer bij de vraag.": "The original document is no longer with the question.",
  "Het besluit is niet doorgekomen. Er is niets gemaakt.": "The decision did not get through. Nothing was made.",
  "Nieuw getal, kijk het na: {getallen}": "New number, check it: {getallen}",
  "Bevestigd: het herschreven bestand staat hieronder, naast het origineel.": "Confirmed: the rewritten file is below, next to the original.",
  "Geweigerd: er is niets gemaakt.": "Declined: nothing was made.",
  // B3 deel 1, de akkoordlijst op de kaart van een koppelaanroep (GL216, 29 okt 2026)
  "Dit verstuurt iets. Er gebeurt niets tot je bevestigt.": "This sends something. Nothing happens until you confirm.",
  "Dit is een betaling. Er gebeurt niets tot je bevestigt.": "This is a payment. Nothing happens until you confirm.",
  "Dit ondertekent of keurt iets goed. Er gebeurt niets tot je bevestigt.": "This signs or approves something. Nothing happens until you confirm.",
  "Dit verwijdert iets. Er gebeurt niets tot je bevestigt.": "This deletes something. Nothing happens until you confirm.",
  // B6 deel 1, per gereedschap wat NovaMund mag (GL216, 29 okt 2026)
  "Leest direct": "Reads directly",
  "Na jouw klik": "After your click",
  "Na jouw klik: {soort}": "After your click: {soort}",
  "verstuurt iets": "sends something",
  "een betaling": "a payment",
  "ondertekent of keurt goed": "signs or approves",
  "verwijdert iets": "deletes something",
  // De sluitknop van een venster en een paneel (Frank, 18 okt 2026)
  "Sluiten": "Close",
  // H8, terugschrijven per soort (18 okt 2026)
  "Per soort:": "Per kind:",
  "Notities": "Notes",
  "Sessielogs": "Session logs",
  "Bijlagen": "Attachments",
  "(eigen regel)": "(own rule)",
  "(volgt de schakelaar hierboven)": "(follows the switch above)",
  "Een bijlage (geen markdown) wordt ook met deze regel aan nooit teruggeschreven.": "An attachment (not markdown) is never written back, even with this rule on.",
  "uit {map}": "from {map}",
  "{naam} verwijderen?": "Delete {naam}?",
  "Dit verwijdert het bestand zelf. Het verdwijnt uit elk project dat het gebruikt en uit {kennisbank}, en dat is niet terug te draaien. Wil je het alleen uit dit project halen, gebruik dan Uit het project halen.": "This removes the file itself. It disappears from every project that uses it and from {kennisbank}, and it cannot be undone. To take it out of this project only, use Remove from project.",
  "de kennisbank": "its knowledge base",
  "Teams": "Teams",
  "1 lid": "1 member",
  "{n} leden": "{n} members",
  "abonnement {plan}": "{plan} plan",
  "{goed} geverifieerd, {kapot} gebroken, {los} zonder keten.": "{goed} verified, {kapot} broken, {los} unchained.",
  "App": "App",
  "Backend": "Backend",
  "Bundel": "Bundle",
  "antwoordt niet": "not answering",
  "Code": "Code",
  "{van} tot {tot}, ingetrokken.": "{van} to {tot}, revoked.",
  "Nu terugkijken": "Look back now",
  "Dit verwijdert alle {n} dingen die Novamund heeft geleerd, in elk project en elke werkruimte. Dat is niet terug te draaien.": "This removes all {n} things Novamund learned, across every project and workspace. It cannot be undone.",
  "Galaxy-skills": "Galaxy Skills",
  "Mijn skills ({n})": "My Skills ({n})",
  "Toegang tot gereedschap voor {naam}": "Tool access for {naam}",
  "Alle chats": "All chats",
  "Geen project met \"{filter}\"": "No project with \"{filter}\"",
  "Of voer het open bestand zelf uit": "Or run the open file yourself",
  "Mailconcepten opstellen": "Draft mail replies",
  "alleen het Gmail-bericht waarvan het id in de opdracht staat, en verstuurt niets": "only the Gmail message whose id is in the task, and sends nothing",
  "Mailconcept aan {aan}: {onderwerp}": "Mail draft to {aan}: {onderwerp}",
  "Bekijken en zelf versturen": "Review and send it yourself",
  "Er is niets verstuurd. Lees het concept na en verstuur het zelf, of niet.": "Nothing was sent. Read the draft and send it yourself, or not.",
  "Feitencontrole": "Fact Check",
  "Gegevens uit tabellen": "Structured Data Pull",
  "Stresstest voor een tekst": "Essay Stress Test",
  "Ideeënvinder": "Idea Finder",
  "Lokaal je mail sorteren, samenvatten en antwoorden opstellen over je geïmporteerde mailarchief. Je mail komt nooit bij een derde.": "Local email triage, summaries and draft replies over your imported email archive. Your email never touches a third party.",
  "Stelt inzageverzoeken op, brengt je digitale voetafdruk in kaart en schrijft de berichten bij een datalek.": "Drafts data subject access requests, maps your digital footprint, and drafts breach-response communications.",
  "Begeleidt je bij het importeren van archieven, notities en documenten in je eigen kennisbank, zodat zoeken vanaf dag een werkt.": "Guides you through importing archives, notes and documents into your own knowledge base, so search works from day one.",
  "Beoordeelt contracten en documenten in je eigen documentopslag. Wat vertrouwelijk is, blijft op je apparaat.": "Contract and document review over your own document store. Legal privilege stays on device.",
  "Onderzoekt concurrenten, markten en actuele webgegevens, gestructureerd en met bronnen.": "Research competitors, markets and live web data in a structured, source-backed way.",
  "Checklists om klaar te zijn voor eIDAS 2.0, NIS2 en de AI Act, gericht op kleinere bedrijven.": "Readiness checklists for eIDAS 2.0, NIS2 and the AI Act, aimed at smaller businesses.",
  "Maakt van ruwe vergaderverslagen of losse aantekeningen een gestructureerd verslag met eigenaren en deadlines.": "Turn raw meeting transcripts or rough notes into structured minutes with owners and deadlines.",
  "Maakt beeldconcepten, merkmateriaal en teksten, nauwkeurig en in lijn met je merk.": "Generate visuals concepts, brand assets and copy with precision and brand consistency.",
  "Houdt alles wat je maakt in lijn met de stem, de termen en de stijlregels van je merk.": "Keep every piece of output consistent with your brand voice, terminology and style rules.",
  "Beoordeelt, legt uit en verbetert code met de grondigheid van een ervaren ontwikkelaar.": "Review, explain and improve code with the rigor of a senior engineer.",
  "Analyseert de marktdynamiek en maakt er concrete groeistrategieën voor een bedrijf van.": "Analyze market dynamics and synthesize concrete growth strategies for a business.",
  "creatief": "creative",
  "techniek": "engineering",
  "naleving": "compliance",
  "soevereiniteit": "sovereignty",
  "onderzoek": "research",
  "groei": "growth",
  "productiviteit": "productivity",
  "meegeleverd": "bundled",
  "door jou geschreven": "written by you",
  "geïmporteerd bestand": "imported file",
  "van een andere node": "from another node",
  "Laat je het leeg, dan doet hij zijn vaste taak: {taak}": "Leave it empty and it does its standing task: {taak}",
  "Geteld tegen de volledige keten van elk gesprek, niet tegen deze selectie.": "Verified against each conversation's full chain, not against this selection.",
  "Hij gebruikt het gereedschap dat hieronder is aangevinkt.": "It uses the tools ticked below.",
  "Er is geen gereedschap aangevinkt.": "No tools are ticked.",
  "Webpagina": "Web page",
  // ZL2a: de duim op een antwoord.
  "Goed antwoord": "Good answer",
  "Geen goed antwoord": "Not a good answer",
  "Je oordeel kon niet worden opgeslagen.": "Your rating could not be saved.",
  // ZL2b: overnemen of aanpassen naast de duim.
  "Antwoord overnemen": "Use this answer",
  "Antwoord aanpassen": "Edit this answer",
  "Aangepaste tekst": "Edited text",
  "Je aangepaste tekst is opgeslagen.": "Your edited text is saved.",
  "Ongewijzigd, dus overgenomen.": "Unchanged, so used as it is.",
  "Je keuze kon niet worden opgeslagen.": "Your choice could not be saved.",
  // GL206-3: de stopzin die de dienst opslaat (`backend/services/beurtstop.py::GESTOPT`).
  "Gestopt: je drukte op Stop. Er is geen antwoord afgemaakt.": "Stopped: you pressed Stop. No answer was finished.",
  "web aan": "web on",
  "web uit": "web off",
  "Project verwijderen": "Delete project",
  "Project {naam} verwijderen?": "Delete project {naam}?",
  "Alleen het project verdwijnt. De chats gaan naar Geen project; kennisbanken, documenten en geheugen blijven bestaan.": "Only the project goes. Its chats move to No project; knowledge bases, documents and memory stay.",
  "Zoek een koppeling": "Search connections",
  "Jouw koppelingen": "Your connections",
  "Ontdekken": "Discover",
  "Geen koppeling met \"{zoek}\"": "No connection with \"{zoek}\"",
  "{naam} gekoppeld": "{naam} connected",
  "Meerdere aangesloten webwinkels: producten zoeken, offertes en bestellinks. Bestellen en betalen doe je bij de winkel.": "Several connected web shops: search products, quotes and order links. You order and pay at the shop.",
  "Naam (optioneel)": "Name (optional)",
  "Zonder naam krijgt de server bij de eerste toets de naam die hij zelf opgeeft.": "Without a name, the server gets the name it gives itself at the first test.",
  "Verbonden": "Connected",
  "Opnieuw inloggen": "Sign in again",
  "Fout": "Error",
  "{naam} aan": "{naam} on",
  "Uit": "Off",
  "De chat wil een gereedschap van een koppeling aanroepen": "The chat wants to call a tool of a connection",
  "Koppelingen in dit gesprek": "Connections in this conversation",
  "Nog geen koppelingen.": "No connections yet.",
  "Koppelingen beheren": "Manage connections",
  "Inloggen": "Log in",
  "Ingelogd bij de server": "Logged in to the server",
  "Een voorstel om je geheugen op te ruimen.": "One proposal to tidy up your memory.",
  "{n} voorstellen over regels die op elkaar lijken.": "{n} proposals about rules that look alike.",
  "Samenvoegen houdt de regel die het meest gebruikt is.": "Merging keeps the rule that is used most.",
  "Vervangen houdt de nieuwste regel.": "Replacing keeps the newest rule.",
  "{n} voorstellen vervangen? De regels die weggaan, zijn daarna weg.": "Replace {n} proposals? The rules that go are gone afterwards.",
  "{n} voorstellen houden? Alle regels blijven staan.": "Keep {n} proposals? All rules stay.",
  "Voeg deze groep samen": "Merge this group",
  "Vervang deze groep": "Replace this group",
  "Houd deze groep": "Keep this group",
  "Verberg de voorstellen": "Hide the proposals",
  "Toon de {n} voorstellen": "Show the {n} proposals",
  "Ja, doe het": "Yes, do it",
  "Nee": "No",
  "Geheugen opruimen: {n} voorstellen in {g} groepen.": "Tidy up memory: {n} proposals in {g} groups.",
  // B (23 okt): Postbus met twee tabbladen, opruimen en koppen in de taal van de app.
  "Nog niets in de postbus. De ochtendronde komt elke dag om 07:30.": "Nothing in the inbox yet. The morning round arrives every day at 07:30.",
  "{n} gelezen kaarten verwijderen? Ze zijn daarna weg.": "Delete {n} read cards? They are gone afterwards.",
  "Alles gelezen verwijderen ({n})": "Delete all read ({n})",
  "Niets in dit tabblad.": "Nothing in this tab.",
  "Eerdere rondes ({n})": "Earlier rounds ({n})",
  "Ochtendronde {dag} {datum}": "Morning round {dag} {datum}",
  "Skill voorstellen: {naam}": "Skill proposal: {naam}",
  "Nieuwe kennisbank: {naam}": "New knowledge base: {naam}",
  "Hij hangt aan het project {project}.": "It belongs to the project {project}.",
  "De map {map} in je vault is nu een kennisbank. Hij wordt bij deze synchronisatie ingelezen en staat onder Kennisbanken.": "The folder {map} in your vault is now a knowledge base. It is read in during this sync and is listed under Knowledge bases.",
  "De map {map} in je vault is nu het project {project}, met de kennisbank {bank}.": "The folder {map} in your vault is now the project {project}, with the knowledge base {bank}.",
  "De {aantal} losse bestanden in je vault, buiten een map, staan nu in de kennisbank Losse bestanden in het project {project}.": "The {aantal} loose files in your vault, outside any folder, are now in the knowledge base Loose files in the project {project}.",
  "De map {map} heet nu {nieuw}. De kennisbank {bank} volgt hem; er is niets opnieuw ingelezen.": "The folder {map} is now called {nieuw}. The knowledge base {bank} follows it; nothing was read in again.",
  "De map {map} staat nu in {nieuw}, en die valt al onder de kennisbank van {onder}. De kennisbank {bank} houdt zijn oude stukken tot jij beslist.": "The folder {map} is now in {nieuw}, which already falls under the knowledge base of {onder}. The knowledge base {bank} keeps its old documents until you decide.",
  "De map {map} staat niet meer in je vault. De kennisbank {bank} blijft staan met wat hij had; weggooien doe jij.": "The folder {map} is no longer in your vault. The knowledge base {bank} stays with what it had; deleting it is up to you.",
  "Deze bestanden staan niet meer in je vault en zijn uit hun kennisbank gehaald:": "These files are no longer in your vault and have been removed from their knowledge base:",
  "Deze bestanden in je vault zijn niet ingelezen, met de reden:": "These files in your vault were not read in, with the reason:",
  "Er kwamen {nieuw} bestanden bij die niet zijn ingelezen, met de reden. Het volledige overzicht staat onder Kennis, bij Niet ingelezen.": "{nieuw} files were added that were not read in, with the reason. The full overview is under Knowledge, at Not read in.",
  "Er zijn {minder} bestanden minder die niet zijn ingelezen, en er kwam niets bij. Het volledige overzicht staat onder Kennis, bij Niet ingelezen.": "{minder} fewer files are not read in, and nothing was added. The full overview is under Knowledge, at Not read in.",
  "Niet ingelezen": "Not read in",
  "Deze vraag stel je vaak. Wil je hem bewaren als skill? Er gebeurt niets tot je kiest.": "You ask this question often. Do you want to keep it as a skill? Nothing happens until you choose.",
  "Vraag:": "Question:",
  "Gesteld in {g} gesprekken op {d} dagen": "Asked in {g} conversations on {d} days",
  "Het overzicht kon niet worden opgehaald.": "The overview could not be fetched.",
  "De vault is nu niet bereikbaar, dus er valt niets te meten.": "The vault cannot be reached right now, so there is nothing to measure.",
  "verborgen bestand": "hidden file",
  "slotbestand van Word": "Word lock file",
  "dubbel met markdown": "duplicate of a markdown file",
  "zelfde naam als een ander los bestand": "same name as another loose file",
  "soort {soort}": "type {soort}",
  "overgeslagen map ({map})": "skipped folder ({map})",
  "inlezen mislukt: {fout}": "reading failed: {fout}",
  "Nieuw project: {naam}": "New project: {naam}",
  "Map hernoemd: {naam}": "Folder renamed: {naam}",
  "Map verplaatst: {naam}": "Folder moved: {naam}",
  "Map verdwenen: {naam}": "Folder gone: {naam}",
  "Uit de vault verwijderd: {n} bestanden": "Removed from the vault: {n} files",
  "Niet ingelezen: {n} bestanden": "Not read in: {n} files",
  "{map}: {aantal} keer {reden}": "{map}: {aantal} times {reden}",
  "en nog {n}": "and {n} more",
  "Opent het formulier voor een nieuw project, met de naam ingevuld": "Opens the form for a new project, with the name filled in",
  "Opent het formulier voor een nieuwe kennisbank, met de naam ingevuld": "Opens the form for a new knowledge base, with the name filled in",
  "Opent het formulier voor een nieuw team, met de naam ingevuld": "Opens the form for a new team, with the name filled in",
  "Opent het formulier voor een nieuwe skill, met de naam ingevuld": "Opens the form for a new skill, with the name filled in",
  "(losse bestanden in de vault)": "(loose files at the top of the vault)",
  "soort zonder extensie": "type without extension",
  "Overgeslagen mappen, niet meegeteld: {aantal} bestanden in {mappen}": "Skipped folders, not counted: {aantal} files in {mappen}",
  "Geheugen opruimen: een regel lijkt ingehaald door een nieuwere": "Tidy up memory: a line seems overtaken by a newer one",
  "Geheugen opruimen: twee regels zeggen hetzelfde": "Tidy up memory: two lines say the same thing",
  "Selectie vervangen ({n})": "Replace selection ({n})",
  "Selectie houden ({n})": "Keep selection ({n})",
  "Alles vervangen ({n})": "Replace all ({n})",
  "Alles houden ({n})": "Keep all ({n})",
  "(niet meer leesbaar)": "(no longer readable)",
  "Gereedschappen ({n}, {aan} aan)": "Tools ({n}, {aan} on)",
  "Servers die gereedschap geven aan de chat en aan je agents. Lezen en zoeken gaat direct; bestellen, een link maken of iets aanvragen wacht eerst op je bevestiging.": "Servers that give tools to the chat and to your agents. Reading and searching run at once; ordering, creating a link or requesting something waits for your confirmation first.",
  "MCP-gereedschap. Lezen en zoeken gaat direct; bestellen, een link maken of iets aanvragen wacht eerst op je bevestiging.": "MCP tools. Reading and searching run at once; ordering, creating a link or requesting something waits for your confirmation first.",
  // Post U: het Universum.
  "Documenten": "Documents",
  "Gesprekken": "Conversations",
  "Universum": "Universe",
  "Zoek in het universum": "Search the universe",
  "Team of project": "Team or project",
  "Alle teams en projecten": "All teams and projects",
  "Universum laden": "Loading universe",
  "Het universum kon niet geladen worden.": "The universe could not be loaded.",
  "Er is nog niets om te tonen.": "There is nothing to show yet.",
  "{s} stippen, {l} verbindingen": "{s} dots, {l} connections",
  "ingekort": "shortened",
  "{n} verbindingen": "{n} connections",
  "Klik op een stip om hem te openen en zijn buren op te lichten.": "Click a dot to open it and light up its neighbours.",
  "Meetings": "Meetings",
  "Personen": "People",
  "Personen uit Fathom": "People from Fathom",
  "Personen laden": "Loading people",
  "Personen konden niet geladen worden.": "People could not be loaded.",
  "Verwijzingen tussen documenten": "Links between documents",
  "Verwijzingen laden": "Loading links",
  "Verwijzingen konden niet geladen worden.": "Links could not be loaded.",
  // GL198-U: het instellingenpaneel van het Universum, naar het voorbeeld van Obsidian.
  "Filters": "Filters",
  "Weergave": "Display",
  "Krachten": "Forces",
  "Labels": "Labels",
  "Alleen bestaande bestanden": "Existing files only",
  "Losse stippen": "Orphans",
  "Pijlen": "Arrows",
  "Drempel voor namen": "Text fade threshold",
  "Stipgrootte": "Node size",
  "Lijndikte": "Link thickness",
  "Animeer": "Animate",
  "Centrale kracht": "Center force",
  "Afstotende kracht": "Repel force",
  "Lijnkracht": "Link force",
  "Lijnafstand": "Link distance",
  "Standaard": "Reset to default",
  "Instellingen verbergen": "Hide settings",
  "Instellingen tonen": "Show settings",
  "Instellingen van het universum": "Universe settings",
  "Een verwijzing naar een bestand dat er niet is.": "A link to a file that does not exist.",
  // DW-e (24 okt 2026): bronnen en tijdstip van een worker bewerken.
  "Mag lezen": "May read",
  "Vast tijdstip": "Fixed time",
  "Hij draait dan vanzelf op deze dagen en dit uur, alleen als de Mac aan staat.": "It then runs by itself on these days at this time, only while the Mac is on.",
  "Tijd": "Time",
  // Universum, 24 okt 2026: personen uit mail, agenda en TASQ.
  "Personen uit mail": "People from mail",
  "Personen uit de agenda": "People from the calendar",
  "Personen uit TASQ": "People from TASQ",
  "Mails": "Mails",
  "Afspraken": "Appointments",
  "Taken": "Tasks",
  // Slash-opdrachten, deel 1 en 2 (24 okt 2026).
  "Toont je open TASQ-taken, alle statussen behalve afgerond": "Shows your open TASQ tasks, every status except done",
  "Toont je mail van vandaag, of van de periode die je erachter zet": "Shows your mail of today, or of the period you put after it",
  "Maakt een voorstel voor een digitale worker: wat, wanneer, welke bronnen en een korte naam": "Makes a proposal for a digital worker: what, when, which sources and a short name",
  "Maakt een voorstel voor een agent; noem je een tijdstip, dan neemt de kaart het over": "Makes a proposal for an agent; name a time and the card takes it over",
  "Nieuwe digitale worker": "New digital worker",
  "vat mijn TASQ-taken samen": "summarise my TASQ tasks",
  "Korte naam (mag leeg)": "Short name (may be empty)",
  "Zonder dag draait hij alleen als je hem start.": "Without a day it only runs when you start it.",
  "Voorstel maken": "Make proposal",
  "Er wordt nog niets aangemaakt: je krijgt eerst een voorstelkaart met Bevestig.": "Nothing is created yet: you first get a proposal card with Confirm.",
  "Maken": "Make",
  "Bronnen lezen": "Read sources",
  "Doen": "Do",
  "Gesprek": "Conversation",
  "Veiligheid": "Safety",
  "Hulp": "Help",
  "Opdrachten": "Commands",
  "Typ / in het invoerveld voor de lijst; verder typen filtert, pijltjes en Enter kiezen.": "Type / in the input for the list; typing more filters it, arrows and Enter choose.",
  "Voorbeeld: {v}": "Example: {v}",
  "Opent het Universum: alle verbindingen als grafiek": "Opens the Universe: every connection as a graph",
  "Opent het Logboek met alle handelingen": "Opens the Log with every action",
  "Opent de Postbus met de ochtendronde en voorstellen": "Opens the Inbox with the morning round and proposals",
  "Opent het Geheugen": "Opens Memory",
  "Opent Koppelingen met je eigen koppelingen en Ontdekken": "Opens Connections with your own connections and Discover",
  "Opent het scherm Skills": "Opens the Skills screen",
  "Opent Agenten met je agents en workers": "Opens Agents with your agents and workers",
  "Opent Instellingen": "Opens Settings",
  "Opent de Tijdmachine: terug naar een eerder moment": "Opens the Time machine: back to an earlier moment",
  "Begint een nieuw gesprek": "Starts a new conversation",
  "Kiest het model voor dit gesprek": "Chooses the model for this conversation",
  "Zoekt een eerder gesprek": "Finds an earlier conversation",
  "Zet orkestratie aan of uit": "Turns orchestration on or off",
  "Kiest de LLM-raad: synthese, consensus of beste van N": "Chooses the LLM council: synthesis, consensus or best of N",
  "Toont alle opdrachten met uitleg en een voorbeeld": "Shows every command with an explanation and an example",
  "Weekmeting": "Weekly measurement",
  "Draaien": "Run",
  "Draaien lukte niet.": "Running failed.",
  "Deze code draaien?": "Run this code?",
  "In de sandbox op deze Mac, zonder netwerk en hooguit 30 seconden. Er draait precies wat hieronder staat.": "In the sandbox on this Mac, without network and for at most 30 seconds. Exactly what is shown below runs.",
  "Ja, draai in de sandbox": "Yes, run in the sandbox",
  "Gestopt na 30 seconden.": "Stopped after 30 seconds.",
  "Klaar, afsluitcode {code}.": "Done, exit code {code}.",
  "Modeladvies: {taak}": "Model advice: {taak}",
  "Meetings opzoeken in Fathom": "Looking up meetings in Fathom",
  "Taken opzoeken in TASQ": "Looking up tasks in TASQ",
  "Het lokale model {model} haalde bij {taak} de laatste weken {scores} van de feiten, onder de grens van {grens}.": "For {taak}, the local model {model} got {scores} of the facts in recent weeks, below the threshold of {grens}.",
  "Voor deze taak is een ander model nodig. NovaMund heeft alleen het lokale model gemeten, dus welk ander model het wel kan, staat nog niet vast. Dit zijn de mogelijkheden, met waar ze draaien:": "This task needs a different model. NovaMund has only measured the local model, so which other model can do it is not yet known. These are the options, with where they run:",
  "NovaMund wisselt niet vanzelf van model. Kiezen doe je zelf in Instellingen.": "NovaMund never switches models by itself. You choose in Settings.",
  "Elke zondagnacht beantwoordt het lokale model twaalf vaste vragen uit vaste bronnen. Per week staat hier hoeveel van de feiten in het antwoord stonden, met jouw duimen en overnames van die week.": "Every Sunday night the local model answers twelve fixed questions from fixed sources. For each week you see how many of the facts were in the answer, next to your thumbs and takeovers of that week.",
  "Nog geen meting. De eerste komt zondagnacht tussen 2 en 6 uur, als de Mac aan staat.": "No measurement yet. The first one comes on Sunday night between 2 and 6, if the Mac is on.",
  "overgeslagen: {reden}": "skipped: {reden}",
  "duim {op} omhoog, {neer} omlaag; {over} overgenomen, {aan} aangepast": "thumbs {op} up, {neer} down; {over} taken over, {aan} edited",
  // GT1 tot GT3 (GO Frank 2 november 2026): repo's in een team, rollen en vier ogen.
  "Dit is een teamrepo: naar {naar} gaat een pull request pas na goedkeuring door een ander teamlid dan de maker, op de stand van nu.": "This is a team repo: a pull request only goes into {naar} after approval by a team member other than its author, on the current state.",
  "De repo hoort nu bij het team.": "The repo now belongs to the team.",
  "De repo is nu persoonlijk.": "The repo is now personal.",
  "Het team kon niet worden gekozen.": "The team could not be chosen.",
  "Teamrepo van een ander lid. Jouw rol: {rol}.": "Team repo of another member. Your role: {rol}.",
  "kijker": "viewer",
  "lid": "member",
  "beheerder": "admin",
  "Team": "Team",
  "Team van deze repo": "Team of this repo",
  "Je rol in het team van deze repo laat dit niet toe. Er is niets veranderd.": "Your role in this repo's team does not allow this. Nothing was changed.",
  "Als kijker (viewer) kun je deze teamrepo alleen lezen. Een werkruimte in Code vraagt de rol lid (member) of beheerder (admin). Er is niets veranderd.": "As a viewer you can only read this team repo. A workspace in Code needs the role member or admin. Nothing was changed.",
  "Alleen de eigenaar van deze repo kan dit. Er is niets veranderd.": "Only the owner of this repo can do this. Nothing was changed.",
  "Kies een team waar je lid van bent, en geen kijker. Er is niets veranderd.": "Choose a team you are a member of, not as a viewer. Nothing was changed.",
  "Een pull request naar de hoofdtak van een teamrepo wacht op goedkeuring door een ander teamlid dan de maker, op de stand van nu. Er is niets samengevoegd.": "A pull request into the main branch of a team repo waits for approval by a team member other than its author, on the current state. Nothing was merged.",
  // Glasronde 0.9.234: team en rol zichtbaar, wie goedkeurde en of het telt.
  "Team {team}, jouw rol: {rol}": "Team {team}, your role: {rol}",
  "kijker (viewer)": "viewer",
  "lid (member)": "member",
  "beheerder (admin)": "admin",
  "Teamrepo van een ander lid.": "Team repo of another member.",
  "onbekend team": "unknown team",
  "Goedgekeurd door {naam}": "Approved by {naam}",
  "Wijzigingen gevraagd door {naam}": "Changes requested by {naam}",
  "telt niet: goedkeuring van een ander teamlid nodig": "does not count: approval by another team member needed",
  "telt niet: gegeven op een eerdere stand van de tak": "does not count: given on an earlier state of the branch",
  // Glasronde 0.9.235: filter in Repo's.
  "Alle": "All",
  "Team {team}": "Team {team}",
  "Welke repo's": "Which repos",
  "Geen repo's in dit filter. Kies Alle om alles te zien.": "No repos in this filter. Choose All to see everything.",
  "{model} op {host} ({soort})": "{model} on {host} ({soort})",
  "Of een model op een andere machine in je netwerk": "Or a model on another machine in your network",
  "Adres van die machine": "Address of that machine",
  "Naam van het model": "Name of the model",
  "Gebruik voor Code": "Use for Code",
  "Alleen een machine in je eigen netwerk. NovaMund controleert bij het opslaan of het model daar code kan schrijven; er wordt niets gedownload.": "Only a machine in your own network. When saving, NovaMund checks whether the model there can write code; nothing is downloaded.",
  "Gespreksverslag uit Fathom": "Meeting report from Fathom",
  "Tekens per deel": "Characters per part",
  "Seconden per aanroep": "Seconds per call",
  "Tekens transcript per modelaanroep en de tijdslimiet per aanroep. Leeg is de standaard; met een sneller model kunnen de delen groter.": "Transcript characters per model call and the time limit per call. Empty is the default; with a faster model the parts can be larger.",
  "Niet opgeslagen": "Not saved",
  // MK5 (3 nov): modelprofielen per rol en de terugval.
  "Model per rol": "Model per role",
  "Chat": "Chat",
  "Onderzoek": "Research",
  "Agents": "Agents",
  "Geen terugval": "No fallback",
  "Het model hierboven.": "The model above.",
  "Model voor code, hieronder.": "Model for code, below.",
  "Een onderzoeksvraag op het web.": "A research question on the web.",
  "Een agent zonder eigen model op zijn kaart.": "An agent without its own model on its card.",
  "Een terugval gaat alleen van lokaal naar lokaal: bij een time-out of een model dat niet bestaat antwoordt het terugvalmodel, en het antwoord zegt dat.": "A fallback only goes from local to local: on a time-out or a model that does not exist, the fallback model answers, and the answer says so.",
  "teruggevallen op {model}": "fell back to {model}",
  // MK6 (3 nov): het plusmenu in de volgorde van claude.ai.
  "Vaardigheden": "Skills",
  "Storing: {fout}": "Fault: {fout}",
  "Verslag opslaan": "Save report settings",
  "Een verslagvraag maakt een gespreksverslag uit Fathom (standaard uit)": "A report question makes a meeting report from Fathom (off by default)",
};
